<template>
  <div class="prompt">
    <div v-if=" status == 'off'" class="off d-flex" style="align-items: center;justify-content: center;cursor: pointer;position: relative;z-index: 999;" @click="openStatus">
      <el-image style="width: 20px; height: 20px;margin-right: 5px;cursor: pointer;" 
          :src="require('../assets/img/prompt/robot.png')"
          fit="contain" >
        <div slot="placeholder" class="image-slot"></div>
      </el-image>
      提示词助手
    </div>

    <!-- <div v-else-if="status == 'on'" class="on d-flex"  style="flex-direction: column;"  :style="{  height: mainheight + 'px'  , maxHeight : mainheight + 'px' }"  >
      <div class="line d-flex"  style="margin-bottom: 12px;">
        <el-image style="width: 24px; height: 24px;margin-right: 6px;cursor: pointer;" 
            :src="require('../assets/img/prompt/robot.png')"
            fit="contain" >
          <div slot="placeholder" class="image-slot"></div>
        </el-image>
        提示词助手

        <div style="flex: 1 ;align-items: center;justify-content: flex-end;" class="d-flex">
          <span style="font-size: 16px;font-family: PingFangSC-Regular, PingFang SC;color: #CACAD4;">
            English 
            <el-switch
              style="margin-right: 20px;margin-left: 6px;margin-bottom: 2px;"
              v-model="isEnglish"
              active-color="#006FFF"
              inactive-color="#dddfe5"
              >
            </el-switch>
          </span>

          <el-image style="width: 30px; height: 30px;margin-right: 6px;cursor: pointer;" 
            @click="status = 'off'"
              :src="require('../assets/img/prompt/off.png')"
              fit="contain" >
            <div slot="placeholder" class="image-slot"></div>
          </el-image>
        </div>
      </div>

      <el-tabs v-model="activeName"  :stretch="true"	class="deleteBorder" style="flex: 1;background-color: #111224 ;"> 
        <el-tab-pane label="二次元" name="erci" v-if="drawtype=='text' ? formVuex.model_type == 2 : imgFormVuex.model_type == 2 ">
          <span slot="label" class="label">
            <span style="position: relative;">
              二次元   
              <span class="badge" v-if="(selectedData('er').length) > 0">  {{  selectedData("er").length   }}  </span>
            </span>
          </span>

          <div class="tab_cont" :style="{   maxHeight : (mainheight - 128) + 'px' }">
            <div  v-for="(value,key) in data_er" :key='key'>
              <div class="key">
                {{ key }}
              </div>
              <div class="value d-flex" >
                <div v-for="(valueItem , valueIdx) in value" class="valueItem" 
                  :class="{ active: valueItem.flag }"
                  @click="valueItemClick( 'data_er' , key , valueIdx )">
                  {{  isEnglish ? valueItem.title : valueItem.c_value  }}
                </div>
              </div>
            </div>
          </div>
        </el-tab-pane>

        <el-tab-pane label="常用" name="a">
          <span slot="label" class="label">
            <span style="position: relative;">
              常用   
              <span class="badge" v-if="(selectedData('a').length) > 0">  {{  selectedData("a").length   }}  </span>
            </span>
          </span>
          
          <div class="tab_cont" :style="{   maxHeight : (mainheight - 128) + 'px' }">
            <div  v-for="(value,key) in data_a" :key='key'>
              <div class="key">
                {{ key }}
              </div>
              <div class="value d-flex" >
                <div v-for="(valueItem , valueIdx) in value" class="valueItem" 
                  :class="{ active: valueItem.flag }"
                  @click="valueItemClick( 'data_a' , key , valueIdx )">
                  {{  isEnglish ? valueItem.title : valueItem.c_value  }}
                </div>
              </div>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="人物" name="b">
          <span slot="label" class="label">
            <span style="position: relative;">
              人物   
              <span class="badge" v-if="(selectedData('b').length) > 0">{{  selectedData("b").length   }}</span>
            </span>
          </span>

          <div class="tab_cont" :style="{   maxHeight : (mainheight - 128) + 'px' }">
            <div  v-for="(value,key) in data_b" :key='key'>
              <div class="key">
                {{ key }}
              </div>
              <div class="value d-flex" >
                <div v-for="(valueItem , valueIdx) in value" class="valueItem" 
                  :class="{ active: valueItem.flag }"
                  @click="valueItemClick( 'data_b' , key , valueIdx )">
                  {{  isEnglish ? valueItem.title : valueItem.c_value  }}
                </div>
              </div>
            </div>
          </div>

        </el-tab-pane>
        <el-tab-pane label="角色" name="c">
          <span slot="label" class="label">
            <span style="position: relative;">
              角色   
              <span class="badge" v-if="(selectedData('c').length) > 0">{{  selectedData("c").length   }}</span>
            </span>
          </span>

          <div class="tab_cont" :style="{   maxHeight : (mainheight - 128) + 'px' }">
            <div  v-for="(value,key) in data_c" :key='key'>
              <div class="key">
                {{ key }}
              </div>
              <div class="value d-flex" >
                <div v-for="(valueItem , valueIdx) in value" class="valueItem" 
                  :class="{ active: valueItem.flag }"
                  @click="valueItemClick( 'data_c' , key , valueIdx )">
                  {{  isEnglish ? valueItem.title : valueItem.c_value  }}
                </div>
              </div>
            </div>
          </div>


        </el-tab-pane>
        <el-tab-pane label="五官" name="d">
          <span slot="label" class="label">
            <span style="position: relative;">
              五官   
              <span class="badge" v-if="(selectedData('d').length) > 0">{{  selectedData("d").length   }}</span>
            </span>
          </span>

          <div class="tab_cont" :style="{   maxHeight : (mainheight - 128) + 'px' }">
            <div  v-for="(value,key) in data_d" :key='key'>
              <div class="key">
                {{ key }}
              </div>
              <div class="value d-flex" >
                <div v-for="(valueItem , valueIdx) in value" class="valueItem" 
                  :class="{ active: valueItem.flag }"
                  @click="valueItemClick( 'data_d' , key , valueIdx )">
                  {{  isEnglish ? valueItem.title : valueItem.c_value  }}
                </div>
              </div>
            </div>
          </div>
        </el-tab-pane>

        <el-tab-pane label="表情" name="e">          
          <span slot="label" class="label">
            <span style="position: relative;">
              表情   
              <span class="badge" v-if="(selectedData('e').length) > 0">{{  selectedData("e").length   }}</span>
            </span>
          </span>

          <div class="tab_cont" :style="{   maxHeight : (mainheight - 128) + 'px' }">
            <div  v-for="(value,key) in data_e" :key='key'>
              <div class="key">
                {{ key }}
              </div>
              <div class="value d-flex" >
                <div v-for="(valueItem , valueIdx) in value" class="valueItem" 
                  :class="{ active: valueItem.flag }"
                  @click="valueItemClick( 'data_e' , key , valueIdx )">
                  {{  isEnglish ? valueItem.title : valueItem.c_value  }}
                </div>
              </div>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="头发" name="f">          
          <span slot="label" class="label">
            <span style="position: relative;">
              头发   
              <span class="badge" v-if="(selectedData('f').length) > 0">{{  selectedData("f").length   }}</span>
            </span>
          </span>

          <div class="tab_cont" :style="{   maxHeight : (mainheight - 128) + 'px' }">
            <div  v-for="(value,key) in data_f" :key='key'>
              <div class="key">
                {{ key }}
              </div>
              <div class="value d-flex" >
                <div v-for="(valueItem , valueIdx) in value" class="valueItem" 
                  :class="{ active: valueItem.flag }"
                  @click="valueItemClick( 'data_f' , key , valueIdx )">
                  {{  isEnglish ? valueItem.title : valueItem.c_value  }}
                </div>
              </div>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="服饰" name="g">
          <span slot="label" class="label">
            <span style="position: relative;">
              服饰   
              <span class="badge" v-if="(selectedData('g').length) > 0">{{  selectedData("g").length   }}</span>
            </span>
          </span>

          <div class="tab_cont" :style="{   maxHeight : (mainheight - 128) + 'px' }">
            <div  v-for="(value,key) in data_g" :key='key'>
              <div class="key">
                {{ key }}
              </div>
              <div class="value d-flex" >
                <div v-for="(valueItem , valueIdx) in value" class="valueItem" 
                  :class="{ active: valueItem.flag }"
                  @click="valueItemClick( 'data_g' , key , valueIdx )">
                  {{  isEnglish ? valueItem.title : valueItem.c_value  }}
                </div>
              </div>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="服装" name="h">
          <span slot="label" class="label">
            <span style="position: relative;">
              服装   
              <span class="badge" v-if="(selectedData('h').length) > 0">{{  selectedData("h").length   }}</span>
            </span>
          </span>

          <div class="tab_cont" :style="{   maxHeight : (mainheight - 128) + 'px' }">
            <div  v-for="(value,key) in data_h" :key='key'>
              <div class="key">
                {{ key }}
              </div>
              <div class="value d-flex" >
                <div v-for="(valueItem , valueIdx) in value" class="valueItem" 
                  :class="{ active: valueItem.flag }"
                  @click="valueItemClick( 'data_h' , key , valueIdx )">
                  {{  isEnglish ? valueItem.title : valueItem.c_value  }}
                </div>
              </div>
            </div>
          </div>
        </el-tab-pane>

        <el-tab-pane label="鞋饰" name="i">
          <span slot="label" class="label">
            <span style="position: relative;">
              鞋饰   
              <span class="badge" v-if="(selectedData('i').length) > 0">{{  selectedData("i").length   }}</span>
            </span>
          </span>

          <div class="tab_cont" :style="{   maxHeight : (mainheight - 128) + 'px' }">
            <div  v-for="(value,key) in data_i" :key='key'>
              <div class="key">
                {{ key }}
              </div>
              <div class="value d-flex" >
                <div v-for="(valueItem , valueIdx) in value" class="valueItem" 
                  :class="{ active: valueItem.flag }"
                  @click="valueItemClick( 'data_i' , key , valueIdx )">
                  {{  isEnglish ? valueItem.title : valueItem.c_value  }}
                </div>
              </div>
            </div>
          </div>
        </el-tab-pane>

        <el-tab-pane label="人外特征" name="j">
          <span slot="label" class="label">
            <span style="position: relative;">
              人外特征   
              <span class="badge" v-if="(selectedData('j').length) > 0">{{  selectedData("j").length   }}</span>
            </span>
          </span>

          <div class="tab_cont" :style="{   maxHeight : (mainheight - 128) + 'px' }">
            <div  v-for="(value,key) in data_j" :key='key'>
              <div class="key">
                {{ key }}
              </div>
              <div class="value d-flex" >
                <div v-for="(valueItem , valueIdx) in value" class="valueItem" 
                  :class="{ active: valueItem.flag }"
                  @click="valueItemClick( 'data_j' , key , valueIdx )">
                  {{  isEnglish ? valueItem.title : valueItem.c_value  }}
                </div>
              </div>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="姿势" name="k">
          <span slot="label" class="label">
            <span style="position: relative;">
              姿势   
              <span class="badge" v-if="(selectedData('k').length) > 0">{{  selectedData("k").length   }}</span>
            </span>
          </span>
          <div class="tab_cont" :style="{   maxHeight : (mainheight - 128) + 'px' }">
            <div  v-for="(value,key) in data_k" :key='key'>
              <div class="key">
                {{ key }}
              </div>
              <div class="value d-flex" >
                <div v-for="(valueItem , valueIdx) in value" class="valueItem" 
                  :class="{ active: valueItem.flag }"
                  @click="valueItemClick( 'data_k' , key , valueIdx )">
                  {{  isEnglish ? valueItem.title : valueItem.c_value  }}
                </div>
              </div>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="动作" name="m">
          <span slot="label" class="label">
            <span style="position: relative;">
              动作   
              <span class="badge" v-if="(selectedData('m').length) > 0">{{  selectedData("m").length   }}</span>
            </span>
          </span>
          <div class="tab_cont" :style="{   maxHeight : (mainheight - 128) + 'px' }">
            <div  v-for="(value,key) in data_m" :key='key'>
              <div class="key">
                {{ key }}
              </div>
              <div class="value d-flex" >
                <div v-for="(valueItem , valueIdx) in value" class="valueItem" 
                  :class="{ active: valueItem.flag }"
                  @click="valueItemClick( 'data_m' , key , valueIdx )">
                  {{  isEnglish ? valueItem.title : valueItem.c_value  }}
                </div>
              </div>
            </div>
          </div>
        </el-tab-pane>

        <el-tab-pane label="环境" name="n">
          <span slot="label" class="label">
            <span style="position: relative;">
              环境   
              <span class="badge" v-if="(selectedData('n').length) > 0">{{  selectedData("n").length   }}</span>
            </span>
          </span>

          <div class="tab_cont" :style="{   maxHeight : (mainheight - 128) + 'px' }">
            <div  v-for="(value,key) in data_n" :key='key'>
              <div class="key">
                {{ key }}
              </div>
              <div class="value d-flex" >
                <div v-for="(valueItem , valueIdx) in value" class="valueItem" 
                  :class="{ active: valueItem.flag }"
                  @click="valueItemClick( 'data_n' , key , valueIdx )">
                  {{  isEnglish ? valueItem.title : valueItem.c_value  }}
                </div>
              </div>
            </div>
          </div>
          
        </el-tab-pane>
        <el-tab-pane label="风格" name="o">
          <span slot="label" class="label">
            <span style="position: relative;">
              风格   
              <span class="badge" v-if="(selectedData('o').length) > 0">{{  selectedData("o").length   }}</span>
            </span>
          </span>

          <div class="tab_cont" :style="{   maxHeight : (mainheight - 128) + 'px' }">
            <div  v-for="(value,key) in data_o" :key='key'>
              <div class="key">
                {{ key }}
              </div>
              <div class="value d-flex" >
                <div v-for="(valueItem , valueIdx) in value" class="valueItem" 
                  :class="{ active: valueItem.flag }"
                  @click="valueItemClick( 'data_o' , key , valueIdx )">
                  {{  isEnglish ? valueItem.title : valueItem.c_value  }}
                </div>
              </div>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>   -->

    <el-dialog :visible.sync="statusFlag" class="previewDialog" :show-close="false" @close="dialogCloseMed">
        <div v-if="status == 'on'" class="on d-flex ononon"  style="flex-direction: column;"  :style="{  height: mainheight + 'px'  , maxHeight : mainheight + 'px' }"  >
            <div class="line d-flex"  style="margin-bottom: 12px;">
                <el-image style="width: 24px; height: 24px;margin-right: 6px;cursor: pointer;" 
                    :src="require('../assets/img/prompt/robot.png')"
                    fit="contain" >
                    <div slot="placeholder" class="image-slot"></div>
                </el-image>
                提示词助手

                <div style="flex: 1 ;align-items: center;justify-content: flex-end;" class="d-flex">
                <span style="font-size: 16px;font-family: PingFangSC-Regular, PingFang SC;color: #CACAD4;">
                    English 
                    <el-switch
                    style="margin-right: 20px;margin-left: 6px;margin-bottom: 2px;"
                    v-model="isEnglish"
                    active-color="#006FFF"
                    inactive-color="#dddfe5"
                    >
                    </el-switch>
                </span>

                <el-image style="width: 30px; height: 30px;margin-right: 6px;cursor: pointer;" 
                    @click="offStatus"
                    :src="require('../assets/img/prompt/off.png')"
                    fit="contain" >
                    <div slot="placeholder" class="image-slot"></div>
                </el-image>
                </div>
            </div>

            <el-tabs v-model="activeName"  :stretch="true"	class="deleteBorder" style="flex: 1;background-color: #111224 ;"> 
                <el-tab-pane label="二次元" name="erci" v-if="drawtype=='text' ? formVuex.model_type == 2 : imgFormVuex.model_type == 2 ">
                <span slot="label" class="label">
                    <span style="position: relative;">
                    二次元   
                    <span class="badge" v-if="(selectedData('er').length) > 0">  {{  selectedData("er").length   }}  </span>
                    </span>
                </span>

                <div class="tab_cont" :style="{   maxHeight : (mainheight - 128) + 'px' }">
                    <div  v-for="(value,key) in data_er" :key='key'>
                    <div class="key">
                        {{ key }}
                    </div>
                    <div class="value d-flex" >
                        <div v-for="(valueItem , valueIdx) in value" class="valueItem" 
                        :class="{ active: valueItem.flag }"
                        @click="valueItemClick( 'data_er' , key , valueIdx )">
                        {{  isEnglish ? valueItem.title : valueItem.c_value  }}
                        </div>
                    </div>
                    </div>
                </div>
                </el-tab-pane>

                <el-tab-pane label="常用" name="a">
                <span slot="label" class="label">
                    <span style="position: relative;">
                    常用   
                    <span class="badge" v-if="(selectedData('a').length) > 0">  {{  selectedData("a").length   }}  </span>
                    </span>
                </span>
                
                <div class="tab_cont" :style="{   maxHeight : (mainheight - 128) + 'px' }">
                    <div  v-for="(value,key) in data_a" :key='key'>
                    <div class="key">
                        {{ key }}
                    </div>
                    <div class="value d-flex" >
                        <div v-for="(valueItem , valueIdx) in value" class="valueItem" 
                        :class="{ active: valueItem.flag }"
                        @click="valueItemClick( 'data_a' , key , valueIdx )">
                        {{  isEnglish ? valueItem.title : valueItem.c_value  }}
                        </div>
                    </div>
                    </div>
                </div>
                </el-tab-pane>
                <el-tab-pane label="人物" name="b">
                <span slot="label" class="label">
                    <span style="position: relative;">
                    人物   
                    <span class="badge" v-if="(selectedData('b').length) > 0">{{  selectedData("b").length   }}</span>
                    </span>
                </span>

                <div class="tab_cont" :style="{   maxHeight : (mainheight - 128) + 'px' }">
                    <div  v-for="(value,key) in data_b" :key='key'>
                    <div class="key">
                        {{ key }}
                    </div>
                    <div class="value d-flex" >
                        <div v-for="(valueItem , valueIdx) in value" class="valueItem" 
                        :class="{ active: valueItem.flag }"
                        @click="valueItemClick( 'data_b' , key , valueIdx )">
                        {{  isEnglish ? valueItem.title : valueItem.c_value  }}
                        </div>
                    </div>
                    </div>
                </div>

                </el-tab-pane>
                <el-tab-pane label="角色" name="c">
                <span slot="label" class="label">
                    <span style="position: relative;">
                    角色   
                    <span class="badge" v-if="(selectedData('c').length) > 0">{{  selectedData("c").length   }}</span>
                    </span>
                </span>

                <div class="tab_cont" :style="{   maxHeight : (mainheight - 128) + 'px' }">
                    <div  v-for="(value,key) in data_c" :key='key'>
                    <div class="key">
                        {{ key }}
                    </div>
                    <div class="value d-flex" >
                        <div v-for="(valueItem , valueIdx) in value" class="valueItem" 
                        :class="{ active: valueItem.flag }"
                        @click="valueItemClick( 'data_c' , key , valueIdx )">
                        {{  isEnglish ? valueItem.title : valueItem.c_value  }}
                        </div>
                    </div>
                    </div>
                </div>


                </el-tab-pane>
                <el-tab-pane label="五官" name="d">
                <span slot="label" class="label">
                    <span style="position: relative;">
                    五官   
                    <span class="badge" v-if="(selectedData('d').length) > 0">{{  selectedData("d").length   }}</span>
                    </span>
                </span>

                <div class="tab_cont" :style="{   maxHeight : (mainheight - 128) + 'px' }">
                    <div  v-for="(value,key) in data_d" :key='key'>
                    <div class="key">
                        {{ key }}
                    </div>
                    <div class="value d-flex" >
                        <div v-for="(valueItem , valueIdx) in value" class="valueItem" 
                        :class="{ active: valueItem.flag }"
                        @click="valueItemClick( 'data_d' , key , valueIdx )">
                        {{  isEnglish ? valueItem.title : valueItem.c_value  }}
                        </div>
                    </div>
                    </div>
                </div>
                </el-tab-pane>

                <el-tab-pane label="表情" name="e">          
                <span slot="label" class="label">
                    <span style="position: relative;">
                    表情   
                    <span class="badge" v-if="(selectedData('e').length) > 0">{{  selectedData("e").length   }}</span>
                    </span>
                </span>

                <div class="tab_cont" :style="{   maxHeight : (mainheight - 128) + 'px' }">
                    <div  v-for="(value,key) in data_e" :key='key'>
                    <div class="key">
                        {{ key }}
                    </div>
                    <div class="value d-flex" >
                        <div v-for="(valueItem , valueIdx) in value" class="valueItem" 
                        :class="{ active: valueItem.flag }"
                        @click="valueItemClick( 'data_e' , key , valueIdx )">
                        {{  isEnglish ? valueItem.title : valueItem.c_value  }}
                        </div>
                    </div>
                    </div>
                </div>
                </el-tab-pane>
                <el-tab-pane label="头发" name="f">          
                <span slot="label" class="label">
                    <span style="position: relative;">
                    头发   
                    <span class="badge" v-if="(selectedData('f').length) > 0">{{  selectedData("f").length   }}</span>
                    </span>
                </span>

                <div class="tab_cont" :style="{   maxHeight : (mainheight - 128) + 'px' }">
                    <div  v-for="(value,key) in data_f" :key='key'>
                    <div class="key">
                        {{ key }}
                    </div>
                    <div class="value d-flex" >
                        <div v-for="(valueItem , valueIdx) in value" class="valueItem" 
                        :class="{ active: valueItem.flag }"
                        @click="valueItemClick( 'data_f' , key , valueIdx )">
                        {{  isEnglish ? valueItem.title : valueItem.c_value  }}
                        </div>
                    </div>
                    </div>
                </div>
                </el-tab-pane>
                <el-tab-pane label="服饰" name="g">
                <span slot="label" class="label">
                    <span style="position: relative;">
                    服饰   
                    <span class="badge" v-if="(selectedData('g').length) > 0">{{  selectedData("g").length   }}</span>
                    </span>
                </span>

                <div class="tab_cont" :style="{   maxHeight : (mainheight - 128) + 'px' }">
                    <div  v-for="(value,key) in data_g" :key='key'>
                    <div class="key">
                        {{ key }}
                    </div>
                    <div class="value d-flex" >
                        <div v-for="(valueItem , valueIdx) in value" class="valueItem" 
                        :class="{ active: valueItem.flag }"
                        @click="valueItemClick( 'data_g' , key , valueIdx )">
                        {{  isEnglish ? valueItem.title : valueItem.c_value  }}
                        </div>
                    </div>
                    </div>
                </div>
                </el-tab-pane>
                <el-tab-pane label="服装" name="h">
                <span slot="label" class="label">
                    <span style="position: relative;">
                    服装   
                    <span class="badge" v-if="(selectedData('h').length) > 0">{{  selectedData("h").length   }}</span>
                    </span>
                </span>

                <div class="tab_cont" :style="{   maxHeight : (mainheight - 128) + 'px' }">
                    <div  v-for="(value,key) in data_h" :key='key'>
                    <div class="key">
                        {{ key }}
                    </div>
                    <div class="value d-flex" >
                        <div v-for="(valueItem , valueIdx) in value" class="valueItem" 
                        :class="{ active: valueItem.flag }"
                        @click="valueItemClick( 'data_h' , key , valueIdx )">
                        {{  isEnglish ? valueItem.title : valueItem.c_value  }}
                        </div>
                    </div>
                    </div>
                </div>
                </el-tab-pane>

                <el-tab-pane label="鞋饰" name="i">
                <span slot="label" class="label">
                    <span style="position: relative;">
                    鞋饰   
                    <span class="badge" v-if="(selectedData('i').length) > 0">{{  selectedData("i").length   }}</span>
                    </span>
                </span>

                <div class="tab_cont" :style="{   maxHeight : (mainheight - 128) + 'px' }">
                    <div  v-for="(value,key) in data_i" :key='key'>
                    <div class="key">
                        {{ key }}
                    </div>
                    <div class="value d-flex" >
                        <div v-for="(valueItem , valueIdx) in value" class="valueItem" 
                        :class="{ active: valueItem.flag }"
                        @click="valueItemClick( 'data_i' , key , valueIdx )">
                        {{  isEnglish ? valueItem.title : valueItem.c_value  }}
                        </div>
                    </div>
                    </div>
                </div>
                </el-tab-pane>

                <el-tab-pane label="人外特征" name="j">
                <span slot="label" class="label">
                    <span style="position: relative;">
                    人外特征   
                    <span class="badge" v-if="(selectedData('j').length) > 0">{{  selectedData("j").length   }}</span>
                    </span>
                </span>

                <div class="tab_cont" :style="{   maxHeight : (mainheight - 128) + 'px' }">
                    <div  v-for="(value,key) in data_j" :key='key'>
                    <div class="key">
                        {{ key }}
                    </div>
                    <div class="value d-flex" >
                        <div v-for="(valueItem , valueIdx) in value" class="valueItem" 
                        :class="{ active: valueItem.flag }"
                        @click="valueItemClick( 'data_j' , key , valueIdx )">
                        {{  isEnglish ? valueItem.title : valueItem.c_value  }}
                        </div>
                    </div>
                    </div>
                </div>
                </el-tab-pane>
                <el-tab-pane label="姿势" name="k">
                <span slot="label" class="label">
                    <span style="position: relative;">
                    姿势   
                    <span class="badge" v-if="(selectedData('k').length) > 0">{{  selectedData("k").length   }}</span>
                    </span>
                </span>
                <div class="tab_cont" :style="{   maxHeight : (mainheight - 128) + 'px' }">
                    <div  v-for="(value,key) in data_k" :key='key'>
                    <div class="key">
                        {{ key }}
                    </div>
                    <div class="value d-flex" >
                        <div v-for="(valueItem , valueIdx) in value" class="valueItem" 
                        :class="{ active: valueItem.flag }"
                        @click="valueItemClick( 'data_k' , key , valueIdx )">
                        {{  isEnglish ? valueItem.title : valueItem.c_value  }}
                        </div>
                    </div>
                    </div>
                </div>
                </el-tab-pane>
                <el-tab-pane label="动作" name="m">
                <span slot="label" class="label">
                    <span style="position: relative;">
                    动作   
                    <span class="badge" v-if="(selectedData('m').length) > 0">{{  selectedData("m").length   }}</span>
                    </span>
                </span>
                <div class="tab_cont" :style="{   maxHeight : (mainheight - 128) + 'px' }">
                    <div  v-for="(value,key) in data_m" :key='key'>
                    <div class="key">
                        {{ key }}
                    </div>
                    <div class="value d-flex" >
                        <div v-for="(valueItem , valueIdx) in value" class="valueItem" 
                        :class="{ active: valueItem.flag }"
                        @click="valueItemClick( 'data_m' , key , valueIdx )">
                        {{  isEnglish ? valueItem.title : valueItem.c_value  }}
                        </div>
                    </div>
                    </div>
                </div>
                </el-tab-pane>

                <el-tab-pane label="环境" name="n">
                <span slot="label" class="label">
                    <span style="position: relative;">
                    环境   
                    <span class="badge" v-if="(selectedData('n').length) > 0">{{  selectedData("n").length   }}</span>
                    </span>
                </span>

                <div class="tab_cont" :style="{   maxHeight : (mainheight - 128) + 'px' }">
                    <div  v-for="(value,key) in data_n" :key='key'>
                    <div class="key">
                        {{ key }}
                    </div>
                    <div class="value d-flex" >
                        <div v-for="(valueItem , valueIdx) in value" class="valueItem" 
                        :class="{ active: valueItem.flag }"
                        @click="valueItemClick( 'data_n' , key , valueIdx )">
                        {{  isEnglish ? valueItem.title : valueItem.c_value  }}
                        </div>
                    </div>
                    </div>
                </div>
                
                </el-tab-pane>
                <el-tab-pane label="风格" name="o">
                <span slot="label" class="label">
                    <span style="position: relative;">
                    风格   
                    <span class="badge" v-if="(selectedData('o').length) > 0">{{  selectedData("o").length   }}</span>
                    </span>
                </span>

                <div class="tab_cont" :style="{   maxHeight : (mainheight - 128) + 'px' }">
                    <div  v-for="(value,key) in data_o" :key='key'>
                    <div class="key">
                        {{ key }}
                    </div>
                    <div class="value d-flex" >
                        <div v-for="(valueItem , valueIdx) in value" class="valueItem" 
                        :class="{ active: valueItem.flag }"
                        @click="valueItemClick( 'data_o' , key , valueIdx )">
                        {{  isEnglish ? valueItem.title : valueItem.c_value  }}
                        </div>
                    </div>
                    </div>
                </div>
                </el-tab-pane>
            </el-tabs>
        </div>  
    </el-dialog>

  </div>
</template>

<script>
export default {
  props: {
    mainheight: {
      type: Number,
      default: 400,
    },
    promptArr : {
      type: Array , 
      default : [] , 
    },
    closePrompt: {
      type: Number,
      default : 1 ,
    },
    drawtype: {
      type : String ,
      default : "text"
    },
    promptLanguage : {
      type : String ,
      default : "中文"
    },
  },
  data() {
    return {
        statusFlag : false ,
      status : 'off'  ,
      value : false , 
      isEnglish : true , 

      activeName : "a" , 
      data_er: {
        "特征": [
          {
            "title": "水系 ((water drops)),wet clothes,((beautiful detailed water)),((floating)),dynamic angle",
            "flag": false,
            "value": "((water drops)),wet clothes,((beautiful detailed water)),((floating)),dynamic angle",
            "c_value": "水系"
          },
          {
            "title": "冰系 beautiful detailed glow, (detailed ice), beautiful detailed water",
            "flag": false,
            "value": "beautiful detailed glow, (detailed ice), beautiful detailed water",
            "c_value": "冰系"
          },
          {
            "title": "冰系2 beautiful detailed glow,detailed ice,beautiful detailed water,(floating palaces:1.2),(ice crystal texture wings),（Iridescence and rainbow hair:2.5）",
            "flag": false,
            "value": "beautiful detailed glow,detailed ice,beautiful detailed water,(floating palaces:1.2),(ice crystal texture wings),（Iridescence and rainbow hair:2.5）",
            "c_value": "冰系2"
          },
          {
            "title": "冰系3 beautiful detailed glow,detailed ice,beautiful detailed water, (floating palaces:1.3),(((ice crystal texture wings)))",
            "flag": false,
            "value": "beautiful detailed glow,detailed ice,beautiful detailed water, (floating palaces:1.3),(((ice crystal texture wings)))",
            "c_value": "冰系3"
          },
          {
            "title": "冰雪森林 ((detailed beautiful snow forest with trees)), ((snowflakes)), floating",
            "flag": false,
            "value": "((detailed beautiful snow forest with trees)), ((snowflakes)), floating",
            "c_value": "冰雪森林"
          },
          {
            "title": "核爆 beautiful detailed glow,((flames of war)),(((nuclear explosion behide)))",
            "flag": false,
            "value": "beautiful detailed glow,((flames of war)),(((nuclear explosion behide)))",
            "c_value": "核爆"
          },
          {
            "title": "风系 ((breeze)), flying splashes,  flying petals, wind",
            "flag": false,
            "value": "((breeze)), flying splashes,  flying petals, wind",
            "c_value": "风系"
          },
          {
            "title": "土系 ((surrounded by heavy floating sand flow and floating sharp stones)),((((ink)))),((illustration)),((watercolor))",
            "flag": false,
            "value": "((surrounded by heavy floating sand flow and floating sharp stones)),((((ink)))),((illustration)),((watercolor))",
            "c_value": "土系"
          },
          {
            "title": "雷系 (detailed light), ((lightning in hand)),lightning surrounds",
            "flag": false,
            "value": "(detailed light), ((lightning in hand)),lightning surrounds",
            "c_value": "雷系"
          },
          {
            "title": "圣光 (sunlight),(angel),dynamic angle, floating, wing, halo, floating white silk,(Holy Light),silver stars",
            "flag": false,
            "value": "(sunlight),(angel),dynamic angle, floating, wing, halo, floating white silk,(Holy Light),silver stars",
            "c_value": "圣光"
          },
          {
            "title": "月下芦苇 beautiful detailed pampas grass field, open hakama, surrounded by floating sakura, yellow full moon, beautiful detailed dark midnight sky, messy white long hair",
            "flag": false,
            "value": "beautiful detailed pampas grass field, open hakama, surrounded by floating sakura, yellow full moon, beautiful detailed dark midnight sky, messy white long hair",
            "c_value": "月下芦苇"
          },
          {
            "title": "大自然 beautiful and delicate water, the finest grass, very delicate light, nature, painting, water spray, breeze, flowers and grass meadow, near the water edge, (sunset, starry sky in a circle), randomly d",
            "flag": false,
            "value": "beautiful and delicate water, the finest grass, very delicate light, nature, painting, water spray, breeze, flowers and grass meadow, near the water edge, (sunset, starry sky in a circle), randomly d",
            "c_value": "大自然"
          },
          {
            "title": "森林 (detailed light) , feather, leaves, nature, (sunlight), river, (forest),(bloom)",
            "flag": false,
            "value": "(detailed light) , feather, leaves, nature, (sunlight), river, (forest),(bloom)",
            "c_value": "森林"
          },
          {
            "title": "彩虹 floating and rainbow long hair,Iridescence and rainbow, beautiful detailed starry sky",
            "flag": false,
            "value": "floating and rainbow long hair,Iridescence and rainbow, beautiful detailed starry sky",
            "c_value": "彩虹"
          },
          {
            "title": "黑暗锁链 chain ring, chain storm, dark chain,((wholeblack bloomer)), darkside, night, deep dark, darkness, ((dark clouds)),((ruins)),shadow, death garden",
            "flag": false,
            "value": "chain ring, chain storm, dark chain,((wholeblack bloomer)), darkside, night, deep dark, darkness, ((dark clouds)),((ruins)),shadow, death garden",
            "c_value": "黑暗锁链"
          },
          {
            "title": "火系 beautiful detailed glow, floating ashes, beautiful and detailed explosion, red moon, fire, fire cloud, wings on fire, a cloudy sky, smoke of gunpowder, burning, black dress, dove of peace, (floating cl",
            "flag": false,
            "value": "beautiful detailed glow, floating ashes, beautiful and detailed explosion, red moon, fire, fire cloud, wings on fire, a cloudy sky, smoke of gunpowder, burning, black dress, dove of peace, (floating cl",
            "c_value": "火系"
          },
          {
            "title": "冰城堡 beautiful detailed glow, detailed ice, beautiful detailed water, (magic circle:1.2), (floating palaces:1.3)",
            "flag": false,
            "value": "beautiful detailed glow, detailed ice, beautiful detailed water, (magic circle:1.2), (floating palaces:1.3)",
            "c_value": "冰城堡"
          },
          {
            "title": "黄昏 (water bloom), (delicate glow),  (breeze), long   Flowers meadow,(((sunset)), (less stars form a circle), randomly distributed clouds, (rivers), (willows with branches falling into the water)",
            "flag": false,
            "value": "(water bloom), (delicate glow),  (breeze), long   Flowers meadow,(((sunset)), (less stars form a circle), randomly distributed clouds, (rivers), (willows with branches falling into the water)",
            "c_value": "黄昏"
          },
          {
            "title": "气泡 ((colorful bubble)),(floating),detailed light",
            "flag": false,
            "value": "((colorful bubble)),(floating),detailed light",
            "c_value": "气泡"
          },
          {
            "title": "蔷薇 ((rose)), (vine), cage, bandage, red rope, (detail light), falling rose petals",
            "flag": false,
            "value": "((rose)), (vine), cage, bandage, red rope, (detail light), falling rose petals",
            "c_value": "蔷薇"
          },
          {
            "title": "星空 (starry tornado:1.4), starry Nebula, beautiful detailed sky",
            "flag": false,
            "value": "(starry tornado:1.4), starry Nebula, beautiful detailed sky",
            "c_value": "星空"
          },
          {
            "title": "皎月 ((moon)), starry sky, (lighting particle), fog, snow,(bloom)",
            "flag": false,
            "value": "((moon)), starry sky, (lighting particle), fog, snow,(bloom)",
            "c_value": "皎月"
          },
          {
            "title": "雪月 beautiful detailed glow, detailed ice, beautiful detailed water, (cold full moon), snowflake, (floating cloud:1.2)",
            "flag": false,
            "value": "beautiful detailed glow, detailed ice, beautiful detailed water, (cold full moon), snowflake, (floating cloud:1.2)",
            "c_value": "雪月"
          },
          {
            "title": "森林大火 ((burning forest)), spark, light leaks, burning sky, flame, flames burning around, (flying sparks)",
            "flag": false,
            "value": "((burning forest)), spark, light leaks, burning sky, flame, flames burning around, (flying sparks)",
            "c_value": "森林大火"
          },
          {
            "title": "废土 ((destroyed)),explosion, buildings in disarray, The residual eaves DuanBi, cumulus, mouldy, floating, wind, Dead end machine,(broken robot),(Mechanical robot girl), in the rubble of a devastated city",
            "flag": false,
            "value": "((destroyed)),explosion, buildings in disarray, The residual eaves DuanBi, cumulus, mouldy, floating, wind, Dead end machine,(broken robot),(Mechanical robot girl), in the rubble of a devastated city",
            "c_value": "废土"
          },
          {
            "title": "机娘 mecha clothes, robot girl",
            "flag": false,
            "value": "mecha clothes, robot girl",
            "c_value": "机娘"
          },
          {
            "title": "黄金 Extremely gorgeous metal style, Metal crown with ornate stripes, Various metals background, Sputtered molten iron, floating hair, Hair like melted metal, Clothes made of silver, Clothes with gold lace",
            "flag": false,
            "value": "Extremely gorgeous metal style, Metal crown with ornate stripes, Various metals background, Sputtered molten iron, floating hair, Hair like melted metal, Clothes made of silver, Clothes with gold lace",
            "c_value": "黄金"
          },
          {
            "title": "死灵 ink,(((bone))), (((ribs))), rose, black hair, blue eyes, greyscale, no shadow, simple background, bright skin",
            "flag": false,
            "value": "ink,(((bone))), (((ribs))), rose, black hair, blue eyes, greyscale, no shadow, simple background, bright skin",
            "c_value": "死灵"
          },
          {
            "title": "水晶甲 (((gorgeous crystal armor))),(((crystal wings))),((altocumulus)),(clear_sky),(snow mountain),((flowery flowers)),(flowery bubbles),cloud map plane, crystal, crystal poppies,Brilliant light, thick_coa",
            "flag": false,
            "value": "(((gorgeous crystal armor))),(((crystal wings))),((altocumulus)),(clear_sky),(snow mountain),((flowery flowers)),(flowery bubbles),cloud map plane, crystal, crystal poppies,Brilliant light, thick_coa",
            "c_value": "水晶甲"
          },
          {
            "title": "水森 ((an extremely delicate and beautiful)),floating, (detailed wet clothes), (detailed light),feather, nature, (sunlight), river, floating palace, beautiful and delicate water,(bloom),(shine)",
            "flag": false,
            "value": "((an extremely delicate and beautiful)),floating, (detailed wet clothes), (detailed light),feather, nature, (sunlight), river, floating palace, beautiful and delicate water,(bloom),(shine)",
            "c_value": "水森"
          },
          {
            "title": "冰火系 (blue spark),(red and blue hair),blue eyes, burning sky,flame,Rainbow in the sky,((Flames burning ice)),(((fire  butterflies))),(((ice crystal texture wings))),(Flying sparks),(detailed ice),((a lot",
            "flag": false,
            "value": "(blue spark),(red and blue hair),blue eyes, burning sky,flame,Rainbow in the sky,((Flames burning ice)),(((fire  butterflies))),(((ice crystal texture wings))),(Flying sparks),(detailed ice),((a lot",
            "c_value": "冰火系"
          },
          {
            "title": "龙骑士 (anger), dragon horns, (silver armor), metal, complex pattern, cape, indifference",
            "flag": false,
            "value": "(anger), dragon horns, (silver armor), metal, complex pattern, cape, indifference",
            "c_value": "龙骑士"
          },
          {
            "title": "下坠 ((full body)),(helpless),tear, crying,(((((falling from the sky))))),((Weathering With You)),((falling)),((face towards the sky))，(hair flows upwards),((disheveled hair)),(1 girl), floating, beautiful",
            "flag": false,
            "value": "((full body)),(helpless),tear, crying,(((((falling from the sky))))),((Weathering With You)),((falling)),((face towards the sky))，(hair flows upwards),((disheveled hair)),(1 girl), floating, beautiful",
            "c_value": "下坠"
          },
          {
            "title": "水底 ((underwater)),(beautiful detailed water),((coral)),dynamic angle, floating,(detailed light),floating hair,(splash),((fishes)),leaves dress, feather, nature,(sunlight),(underwater forest),(bloom),(deta",
            "flag": false,
            "value": "((underwater)),(beautiful detailed water),((coral)),dynamic angle, floating,(detailed light),floating hair,(splash),((fishes)),leaves dress, feather, nature,(sunlight),(underwater forest),(bloom),(deta",
            "c_value": "水底"
          },
          {
            "title": "秘境 (extremely detailed CG unity 8k wallpaper),(((masterpiece))), (((best quality))), ((ultra-detailed)), (best illustration),(best shadow), ((an extremely delicate and beautiful)),dynamic angle,floating",
            "flag": false,
            "value": "(extremely detailed CG unity 8k wallpaper),(((masterpiece))), (((best quality))), ((ultra-detailed)), (best illustration),(best shadow), ((an extremely delicate and beautiful)),dynamic angle,floating",
            "c_value": "秘境"
          },
          {
            "title": "绝景 (((masterpiece))), ((the best quality, super fine illustrations, beautiful and delicate water)), ((very delicate light)), ((nature, painting)), ((fine lighting, more transparent stars, high-quality sno",
            "flag": false,
            "value": "(((masterpiece))), ((the best quality, super fine illustrations, beautiful and delicate water)), ((very delicate light)), ((nature, painting)), ((fine lighting, more transparent stars, high-quality sno",
            "c_value": "绝景"
          },
          {
            "title": "摩登时代 1980s (style),simple background, retro artstyle",
            "flag": false,
            "value": "1980s (style),simple background, retro artstyle",
            "c_value": "摩登时代"
          },
          {
            "title": "血刃 (white hair), red long hair, red eyes, (full body), (((with sword))), angry face, (beautiful detailed eyes), Blood drop,Blood fog, floating hair, disheveled hair,  Splashing blood,(Bloodstain)",
            "flag": false,
            "value": "(white hair), red long hair, red eyes, (full body), (((with sword))), angry face, (beautiful detailed eyes), Blood drop,Blood fog, floating hair, disheveled hair,  Splashing blood,(Bloodstain)",
            "c_value": "血刃"
          },
          {
            "title": "巨龙 ((dragon)), ((dragon background))",
            "flag": false,
            "value": "((dragon)), ((dragon background))",
            "c_value": "巨龙"
          },
          {
            "title": "战姬 hair fluttering in the wind,((mechanical arm armor)),((mechanical body armor)),riding motor, bodysuit,((ruins of city in war, fire, burning cars, burning buildings)),air force fleet in the sky",
            "flag": false,
            "value": "hair fluttering in the wind,((mechanical arm armor)),((mechanical body armor)),riding motor, bodysuit,((ruins of city in war, fire, burning cars, burning buildings)),air force fleet in the sky",
            "c_value": "战姬"
          },
          {
            "title": "龙娘 mecha clothes, robot girl, sliver bodysuit, dragon wings, ((a dragon  stands behind the girl)), beautiful detailed sliver dragon armor",
            "flag": false,
            "value": "mecha clothes, robot girl, sliver bodysuit, dragon wings, ((a dragon  stands behind the girl)), beautiful detailed sliver dragon armor",
            "c_value": "龙娘"
          },
          {
            "title": "星蝶 ((Beautiful butterflies in detail)),((Beautiful stars in detail)),(((halter dress ))),particle,(Starry sky in beautiful detail),(Hazy fog),(Ruins of beautiful details),(((Standing on the surface of the",
            "flag": false,
            "value": "((Beautiful butterflies in detail)),((Beautiful stars in detail)),(((halter dress ))),particle,(Starry sky in beautiful detail),(Hazy fog),(Ruins of beautiful details),(((Standing on the surface of the",
            "c_value": "星蝶"
          },
          {
            "title": "学院 blonde wavy hair, (shiny long hair), ((Gothic Lolita)), blue white skirt, ((short skirt)), black Headdress, bowknot, (((hair ornament))), (hair flower), Lace, cross-laced footwear, ribbon-trimmed slee",
            "flag": false,
            "value": "blonde wavy hair, (shiny long hair), ((Gothic Lolita)), blue white skirt, ((short skirt)), black Headdress, bowknot, (((hair ornament))), (hair flower), Lace, cross-laced footwear, ribbon-trimmed slee",
            "c_value": "学院"
          },
          {
            "title": "圣诞 beautiful detailed sky, night, stars, (red plum blossom),((winter)),(((snowflakes))), ((red and white flowers))，(starry sky),(sitting),((colorful)),scenery, lantern,(starfall)",
            "flag": false,
            "value": "beautiful detailed sky, night, stars, (red plum blossom),((winter)),(((snowflakes))), ((red and white flowers))，(starry sky),(sitting),((colorful)),scenery, lantern,(starfall)",
            "c_value": "圣诞"
          },
          {
            "title": "黑白金 ((((melt)))),(((((black and white melt))))),(((wear Black and white Taoist robes))),((((gold and silver lace)))),(((gold and silver lace lace))),(((flowing ((black)) and white background))),extremely",
            "flag": false,
            "value": "((((melt)))),(((((black and white melt))))),(((wear Black and white Taoist robes))),((((gold and silver lace)))),(((gold and silver lace lace))),(((flowing ((black)) and white background))),extremely",
            "c_value": "黑白金"
          },
          {
            "title": "暗鸦 Floating black ashes, Beautiful and detailed black, red moon, ((The black clouds)), (black Wings) , a black cloudy sky, burning, black dress, ((Black fog)), Red eyes, (black smoke), ((Black feathers fl",
            "flag": false,
            "value": "Floating black ashes, Beautiful and detailed black, red moon, ((The black clouds)), (black Wings) , a black cloudy sky, burning, black dress, ((Black fog)), Red eyes, (black smoke), ((Black feathers fl",
            "c_value": "暗鸦"
          },
          {
            "title": "花火大会 dynamic angle, finely detail, (bloom), (shine), glinting stars, ((((best detailed fireworks)))), ((((depth of field)))), (((hanabi))),(((backlight)))",
            "flag": false,
            "value": "dynamic angle, finely detail, (bloom), (shine), glinting stars, ((((best detailed fireworks)))), ((((depth of field)))), (((hanabi))),(((backlight)))",
            "c_value": "花火大会"
          },
          {
            "title": "星之彩 stars in the eyes, messy floating hair, colored inner hair, Starry sky adorns hair, (lots of big colorful Bubble), (pearl), (Galaxy), depth of field",
            "flag": false,
            "value": "stars in the eyes, messy floating hair, colored inner hair, Starry sky adorns hair, (lots of big colorful Bubble), (pearl), (Galaxy), depth of field",
            "c_value": "星之彩"
          },
          {
            "title": "浴血 dynamic angle, detailed wet clothes, blank stare, overexplosure, floating, black long straight, red eyes, aqua eyes, gradient eyes, ((blood)), white dress, frills, ((expressionless)), extremely beautif",
            "flag": false,
            "value": "dynamic angle, detailed wet clothes, blank stare, overexplosure, floating, black long straight, red eyes, aqua eyes, gradient eyes, ((blood)), white dress, frills, ((expressionless)), extremely beautif",
            "c_value": "浴血"
          },
          {
            "title": "光辉 ((messy hair)),(grassland),(yellow eyes),incredibly absurdres,(gold hair),floating hair,Large number of environments,the medieval ,grace,prospect,water eyes,wind,breeze,god ray,lawn,Mountains and lakes",
            "flag": false,
            "value": "((messy hair)),(grassland),(yellow eyes),incredibly absurdres,(gold hair),floating hair,Large number of environments,the medieval ,grace,prospect,water eyes,wind,breeze,god ray,lawn,Mountains and lakes",
            "c_value": "光辉"
          },
          {
            "title": "星天使 sunlight, extremely light, extremely clothes, Holy Light, dynamic angle, Light particle, very long hair, white hair, yellow eyes, glowing eyes, expressionless, ((light smile)), ((((white Tulle skirt)",
            "flag": false,
            "value": "sunlight, extremely light, extremely clothes, Holy Light, dynamic angle, Light particle, very long hair, white hair, yellow eyes, glowing eyes, expressionless, ((light smile)), ((((white Tulle skirt)",
            "c_value": "星天使"
          },
          {
            "title": "黄金律法 blonde hair, yellow eyes, white skin,  mature female, sunrise, golden sky, magnificent architecture, beautiful detailed sky, overexposure, delicate gold metal decorations",
            "flag": false,
            "value": "blonde hair, yellow eyes, white skin,  mature female, sunrise, golden sky, magnificent architecture, beautiful detailed sky, overexposure, delicate gold metal decorations",
            "c_value": "黄金律法"
          },
          {
            "title": "末日 Blood Mist, background Urban rooftop,despair,Blood Cherry Blossom,torn clothes,crying with eyes open,solo,Blood Rain,bandages,Gunpowder smoke,beautiful deatailed shadow, Splashing blood,dust,tyndall ef",
            "flag": false,
            "value": "Blood Mist, background Urban rooftop,despair,Blood Cherry Blossom,torn clothes,crying with eyes open,solo,Blood Rain,bandages,Gunpowder smoke,beautiful deatailed shadow, Splashing blood,dust,tyndall ef",
            "c_value": "末日"
          },
          {
            "title": "赛博朋克 Space opera,Space port,robot arm,elbow gloves,night,glisten,stare,cyberpunk,((((citylight)))),science fiction,bodysuit,Mechanical armor headdress,(bare shoulders)",
            "flag": false,
            "value": "Space opera,Space port,robot arm,elbow gloves,night,glisten,stare,cyberpunk,((((citylight)))),science fiction,bodysuit,Mechanical armor headdress,(bare shoulders)",
            "c_value": "赛博朋克"
          },
          {
            "title": "血战 (white hair),(((red streaked hair))), red eyes, (((full body))),(red hair), (((((Hold a red sword))))), (angry face),((Blood drop)),((Blood fog)),light shafts, soft focus, ((Splashing blood))),Long hai",
            "flag": false,
            "value": "(white hair),(((red streaked hair))), red eyes, (((full body))),(red hair), (((((Hold a red sword))))), (angry face),((Blood drop)),((Blood fog)),light shafts, soft focus, ((Splashing blood))),Long hai",
            "c_value": "血战"
          },
          {
            "title": "飘花 ((ink)),(water color),bloom effect,detailed beautiful grassland with petal,flower,butterfly,necklace,smile,petal,(((surrounded by heavy floating petal flow)))",
            "flag": false,
            "value": "((ink)),(water color),bloom effect,detailed beautiful grassland with petal,flower,butterfly,necklace,smile,petal,(((surrounded by heavy floating petal flow)))",
            "c_value": "飘花"
          }
        ]
      },
      data_a: {
        "图像优化": [
            {
                "title": "大师作品 masterpiece",
                "flag": false,
                "value": "masterpiece",
                "c_value": "大师作品"
            },
            {
                "title": "最好画质 best quality",
                "flag": false,
                "value": "best quality",
                "c_value": "最好画质"
            },
            {
                "title": "更高质量\tofficial art, extremely detailed CG unity 8k wallpaper",
                "flag": false,
                "value": "official art, extremely detailed CG unity 8k wallpaper",
                "c_value": "更高质量"
            },
            {
                "title": "高细节\thighly detailed",
                "flag": false,
                "value": "highly detailed",
                "c_value": "高细节"
            },
            {
                "title": "超高分辨率\tabsurdres",
                "flag": false,
                "value": "absurdres",
                "c_value": "超高分辨率"
            },
            {
                "title": "8k分辨率\t8k resolution",
                "flag": false,
                "value": "8k resolution",
                "c_value": "8k分辨率"
            }
        ],
        "镜头视角": [
            {
                "title": "景深\tDepth of field",
                "flag": false,
                "value": "Depth of field",
                "c_value": "景深"
            },
            {
                "title": "全景\tPanorama",
                "flag": false,
                "value": "Panorama",
                "c_value": "全景"
            },
            {
                "title": "长焦镜头\ttelephoto lens",
                "flag": false,
                "value": "telephoto lens",
                "c_value": "长焦镜头"
            },
            {
                "title": "微距镜头\tmacro lens",
                "flag": false,
                "value": "macro lens",
                "c_value": "微距镜头"
            },
            {
                "title": "全身镜头\tfull body",
                "flag": false,
                "value": "full body",
                "c_value": "全身镜头"
            },
            {
                "title": "中景镜头\tmedium shot",
                "flag": false,
                "value": "medium shot",
                "c_value": "中景镜头"
            },
            {
                "title": "七分身镜头\tcowboy shot",
                "flag": false,
                "value": "cowboy shot",
                "c_value": "七分身镜头"
            },
            {
                "title": "半身像\tprofile picture",
                "flag": false,
                "value": "profile picture",
                "c_value": "半身像"
            },
            {
                "title": "写实肖像\tclose up portrait",
                "flag": false,
                "value": "close up portrait",
                "c_value": "写实肖像"
            },
            {
                "title": "第一人称视角\tPOV",
                "flag": false,
                "value": "POV",
                "c_value": "第一人称视角"
            },
            {
                "title": "鱼眼镜头\tfisheye",
                "flag": false,
                "value": "fisheye",
                "c_value": "鱼眼镜头"
            },
            {
                "title": "部分水下拍摄\tpartially underwater shot",
                "flag": false,
                "value": "partially underwater shot",
                "c_value": "部分水下拍摄"
            }
        ],
        "其他常用": [
          {
              "title": "精致的五官\texquisite facial features",
              "flag": false,
              "value": "exquisite facial features",
              "c_value": "精致的五官"
          },
          {
              "title": "完美的脸\tprefect face",
              "flag": false,
              "value": "prefect face",
              "c_value": "完美的脸"
          },
          {
              "title": "发光皮肤\tshiny skin",
              "flag": false,
              "value": "shiny skin",
              "c_value": "发光皮肤"
          },
          {
              "title": "抽象背景\tabstract background",
              "flag": false,
              "value": "abstract background",
              "c_value": "抽象背景"
          },
          {
              "title": "蒸汽朋克\tsteampunk",
              "flag": false,
              "value": "steampunk",
              "c_value": "蒸汽朋克"
          },
          {
              "title": "赛博朋克\tcyberpunk",
              "flag": false,
              "value": "cyberpunk",
              "c_value": "赛博朋克"
          }
      ]
      },
      data_b: {
        "人物": [
          {
              "title": "女性\tfemale",
              "flag": false,
              "value": "female",
              "c_value": "女性"
          },
          {
              "title": "男性\tmale",
              "flag": false,
              "value": "male",
              "c_value": "男性"
          },
          {
              "title": "女孩\tgirl",
              "flag": false,
              "value": "girl",
              "c_value": "女孩"
          },
          {
              "title": "男孩\tboy",
              "flag": false,
              "value": "boy",
              "c_value": "男孩"
          },
          {
              "title": "正太\tshota",
              "flag": false,
              "value": "shota",
              "c_value": "正太"
          },
          {
              "title": "萝莉\tloli",
              "flag": false,
              "value": "loli",
              "c_value": "萝莉"
          },
          {
              "title": "美少女\tbishoujo",
              "flag": false,
              "value": "bishoujo",
              "c_value": "美少女"
          },
          {
              "title": "美少男\tbishounen",
              "flag": false,
              "value": "bishounen",
              "c_value": "美少男"
          },
          {
              "title": "辣妹\tgyaru",
              "flag": false,
              "value": "gyaru",
              "c_value": "辣妹"
          },
          {
              "title": "大小姐\tojousama",
              "flag": false,
              "value": "ojousama",
              "c_value": "大小姐"
          },
          {
              "title": "Q版人物\tchibi",
              "flag": false,
              "value": "chibi",
              "c_value": "Q版人物"
          },
          {
              "title": "胖子\tfat man",
              "flag": false,
              "value": "fat man",
              "c_value": "胖子"
          },
          {
              "title": "伪娘\tcrossdressing",
              "flag": false,
              "value": "crossdressing",
              "c_value": "伪娘"
          },
          {
              "title": "天使\tangel",
              "flag": false,
              "value": "angel",
              "c_value": "天使"
          },
          {
              "title": "魔鬼\tdevil",
              "flag": false,
              "value": "devil",
              "c_value": "魔鬼"
          },
          {
              "title": "迷你女孩\tminigirl",
              "flag": false,
              "value": "minigirl",
              "c_value": "迷你女孩"
          },
          {
              "title": "非人\tno_humans",
              "flag": false,
              "value": "no_humans",
              "c_value": "非人"
          },
          {
              "title": "雌小鬼\tmesugaki",
              "flag": false,
              "value": "mesugaki",
              "c_value": "雌小鬼"
          },
          {
              "title": "怪物\tmonster",
              "flag": false,
              "value": "monster",
              "c_value": "怪物"
          },
          {
              "title": "老人\telder",
              "flag": false,
              "value": "elder",
              "c_value": "老人"
          },
          {
              "title": "富豪\trich man",
              "flag": false,
              "value": "rich man",
              "c_value": "富豪"
          },
          {
              "title": "乞丐\tbeggar",
              "flag": false,
              "value": "beggar",
              "c_value": "乞丐"
          },
          {
              "title": "巨人\ttitans",
              "flag": false,
              "value": "titans",
              "c_value": "巨人"
          },
          {
              "title": "侏儒\tdwarf",
              "flag": false,
              "value": "dwarf",
              "c_value": "侏儒"
          },
          {
              "title": "小丑\tclown",
              "flag": false,
              "value": "clown",
              "c_value": "小丑"
          },
          {
              "title": "奴隶\tslave",
              "flag": false,
              "value": "slave",
              "c_value": "奴隶"
          },
          {
              "title": "雪女\tyukiwo",
              "flag": false,
              "value": "yukiwo",
              "c_value": "雪女"
          },
          {
              "title": "酋长\tsheik",
              "flag": false,
              "value": "sheik",
              "c_value": "酋长"
          },
          {
              "title": "女王\tqueen",
              "flag": false,
              "value": "queen",
              "c_value": "女王"
          },
          {
              "title": "女神\tgoddess",
              "flag": false,
              "value": "goddess",
              "c_value": "女神"
          },
          {
              "title": "公主\tprincess",
              "flag": false,
              "value": "princess",
              "c_value": "公主"
          },
          {
              "title": "王子\tprince",
              "flag": false,
              "value": "prince",
              "c_value": "王子"
          },
          {
              "title": "新娘\tbride",
              "flag": false,
              "value": "bride",
              "c_value": "新娘"
          },
          {
              "title": "新郎\tbridegroom",
              "flag": false,
              "value": "bridegroom",
              "c_value": "新郎"
          },
          {
              "title": "肌肉男\tmuscle man",
              "flag": false,
              "value": "muscle man",
              "c_value": "肌肉男"
          },
          {
              "title": "偶像\tidol",
              "flag": false,
              "value": "idol",
              "c_value": "偶像"
          },
          {
              "title": "兔女郎\tbunny girl",
              "flag": false,
              "value": "bunny girl",
              "c_value": "兔女郎"
          },
          {
              "title": "怪物女孩\tmonster girl",
              "flag": false,
              "value": "monster girl",
              "c_value": "怪物女孩"
          },
          {
              "title": "狐狸女孩\tfox girl",
              "flag": false,
              "value": "fox girl",
              "c_value": "狐狸女孩"
          },
          {
              "title": "狼女孩\twolf girl",
              "flag": false,
              "value": "wolf girl",
              "c_value": "狼女孩"
          },
          {
              "title": "猫女孩\tcat girl",
              "flag": false,
              "value": "cat girl",
              "c_value": "猫女孩"
          },
          {
              "title": "木偶\tmarionette",
              "flag": false,
              "value": "marionette",
              "c_value": "木偶"
          },
          {
              "title": "黏土手办\tnendoroid",
              "flag": false,
              "value": "nendoroid",
              "c_value": "黏土手办"
          }
      ],
        "数量": [
          {
              "title": "单人\tsolo",
              "flag": false,
              "value": "solo",
              "c_value": "单人"
          },
          {
              "title": "多个女孩\tmultiple girls",
              "flag": false,
              "value": "multiple girls",
              "c_value": "多个女孩"
          },
          {
              "title": "双胞胎\ttwins",
              "flag": false,
              "value": "twins",
              "c_value": "双胞胎"
          },
          {
              "title": "三胞胎\ttriplets",
              "flag": false,
              "value": "triplets",
              "c_value": "三胞胎"
          },
          {
              "title": "兄弟姐妹\tbrother and sister",
              "flag": false,
              "value": "brother and sister",
              "c_value": "兄弟姐妹"
          }
      ]
      },
      data_c: {
        "职业": [
      {
          "title": "救生员\tlifeguard",
          "flag": false,
          "value": "lifeguard",
          "c_value": "救生员"
      },
      {
          "title": "拳击手\tboxer",
          "flag": false,
          "value": "boxer",
          "c_value": "拳击手"
      },
      {
          "title": "科学家\tscientist",
          "flag": false,
          "value": "scientist",
          "c_value": "科学家"
      },
      {
          "title": "运动员\tathletes",
          "flag": false,
          "value": "athletes",
          "c_value": "运动员"
      },
      {
          "title": "职场女性\toffice lady",
          "flag": false,
          "value": "office lady",
          "c_value": "职场女性"
      },
      {
          "title": "和尚\tmonk",
          "flag": false,
          "value": "monk",
          "c_value": "和尚"
      },
      {
          "title": "杂技演员\tcrobat",
          "flag": false,
          "value": "crobat",
          "c_value": "杂技演员"
      },
      {
          "title": "修女\tnun",
          "flag": false,
          "value": "nun",
          "c_value": "修女"
      },
      {
          "title": "护士\tnurse",
          "flag": false,
          "value": "nurse",
          "c_value": "护士"
      },
      {
          "title": "空姐\tstewardess",
          "flag": false,
          "value": "stewardess",
          "c_value": "空姐"
      },
      {
          "title": "学生\tstudent",
          "flag": false,
          "value": "student",
          "c_value": "学生"
      },
      {
          "title": "女服务员\twaitress",
          "flag": false,
          "value": "waitress",
          "c_value": "女服务员"
      },
      {
          "title": "老师\tteacher",
          "flag": false,
          "value": "teacher",
          "c_value": "老师"
      },
      {
          "title": "赛车手\tracer",
          "flag": false,
          "value": "racer",
          "c_value": "赛车手"
      },
      {
          "title": "警察\tpolice",
          "flag": false,
          "value": "police",
          "c_value": "警察"
      },
      {
          "title": "士兵\tsoldier",
          "flag": false,
          "value": "soldier",
          "c_value": "士兵"
      },
      {
          "title": "啦啦队\tcheerleader",
          "flag": false,
          "value": "cheerleader",
          "c_value": "啦啦队"
      },
      {
          "title": "男演员\tactor",
          "flag": false,
          "value": "actor",
          "c_value": "男演员"
      },
      {
          "title": "女演员\tactress",
          "flag": false,
          "value": "actress",
          "c_value": "女演员"
      },
      {
          "title": "间谍\tspy",
          "flag": false,
          "value": "spy",
          "c_value": "间谍"
      },
      {
          "title": "特工\tagent",
          "flag": false,
          "value": "agent",
          "c_value": "特工"
      },
      {
          "title": "刺客\tassassin",
          "flag": false,
          "value": "assassin",
          "c_value": "刺客"
      },
      {
          "title": "诗人\tpoet",
          "flag": false,
          "value": "poet",
          "c_value": "诗人"
      },
      {
          "title": "日本武士\tsamurai",
          "flag": false,
          "value": "samurai",
          "c_value": "日本武士"
      },
      {
          "title": "舞女\tdancing girl",
          "flag": false,
          "value": "dancing girl",
          "c_value": "舞女"
      },
      {
          "title": "摩托车手\tmotorcyclist",
          "flag": false,
          "value": "motorcyclist",
          "c_value": "摩托车手"
      },
      {
          "title": "黑客\thacker",
          "flag": false,
          "value": "hacker",
          "c_value": "黑客"
      },
      {
          "title": "魔术师\tmagician",
          "flag": false,
          "value": "magician",
          "c_value": "魔术师"
      },
      {
          "title": "侦探\tdetective",
          "flag": false,
          "value": "detective",
          "c_value": "侦探"
      },
      {
          "title": "人偶\tdoll",
          "flag": false,
          "value": "doll",
          "c_value": "人偶"
      },
      {
          "title": "女仆\tmaid",
          "flag": false,
          "value": "maid",
          "c_value": "女仆"
      },
      {
          "title": "飞行员\tpilot",
          "flag": false,
          "value": "pilot",
          "c_value": "飞行员"
      },
      {
          "title": "潜水员\tdiver",
          "flag": false,
          "value": "diver",
          "c_value": "潜水员"
      },
      {
          "title": "酒吧审查员\tbar censor",
          "flag": false,
          "value": "bar censor",
          "c_value": "酒吧审查员"
      },
      {
          "title": "传教士\tmissionary",
          "flag": false,
          "value": "missionary",
          "c_value": "传教士"
      },
      {
          "title": "消防员\tfirefighter",
          "flag": false,
          "value": "firefighter",
          "c_value": "消防员"
      },
      {
          "title": "守门员\tgoalkeeper",
          "flag": false,
          "value": "goalkeeper",
          "c_value": "守门员"
      },
      {
          "title": "厨师\tchef",
          "flag": false,
          "value": "chef",
          "c_value": "厨师"
      },
      {
          "title": "宇航员\tastronaut",
          "flag": false,
          "value": "astronaut",
          "c_value": "宇航员"
      },
      {
          "title": "收银员\tcashier",
          "flag": false,
          "value": "cashier",
          "c_value": "收银员"
      },
      {
          "title": "邮递员\tmailman",
          "flag": false,
          "value": "mailman",
          "c_value": "邮递员"
      },
      {
          "title": "咖啡师\tbarista",
          "flag": false,
          "value": "barista",
          "c_value": "咖啡师"
      },
      {
          "title": "隐士\tthe hermit",
          "flag": false,
          "value": "the hermit",
          "c_value": "隐士"
      },
      {
          "title": "牧羊人\tmakihitsuji",
          "flag": false,
          "value": "makihitsuji",
          "c_value": "牧羊人"
      }
  ],
        "动漫": [
          {
              "title": "宝可梦\tpokemon",
              "flag": false,
              "value": "pokemon",
              "c_value": "宝可梦"
          },
          {
              "title": "泰迪熊\tteddy bear",
              "flag": false,
              "value": "teddy bear",
              "c_value": "泰迪熊"
          },
          {
              "title": "马里奥\tmario",
              "flag": false,
              "value": "mario",
              "c_value": "马里奥"
          },
          {
              "title": "皮卡丘\tpikachu",
              "flag": false,
              "value": "pikachu",
              "c_value": "皮卡丘"
          },
          {
              "title": "新世纪福音战士\tneon genesis evangelion",
              "flag": false,
              "value": "neon genesis evangelion",
              "c_value": "新世纪福音战士"
          },
          {
              "title": "初音未来\thatsune miku",
              "flag": false,
              "value": "hatsune miku",
              "c_value": "初音未来"
          },
          {
              "title": "哈利波特\tharry potter",
              "flag": false,
              "value": "harry potter",
              "c_value": "哈利波特"
          },
          {
              "title": "哆啦A梦\tdoraemon",
              "flag": false,
              "value": "doraemon",
              "c_value": "哆啦A梦"
          },
          {
              "title": "圣斗士星矢\tsaint seiya",
              "flag": false,
              "value": "saint seiya",
              "c_value": "圣斗士星矢"
          },
          {
              "title": "五条悟\tgojou satoru",
              "flag": false,
              "value": "gojou satoru",
              "c_value": "五条悟"
          },
          {
              "title": "复仇者联盟\tavengers",
              "flag": false,
              "value": "avengers",
              "c_value": "复仇者联盟"
          },
          {
              "title": "神奇女侠\tmazinger",
              "flag": false,
              "value": "mazinger",
              "c_value": "神奇女侠"
          },
          {
              "title": "美国队长\tcaptain america",
              "flag": false,
              "value": "captain america",
              "c_value": "美国队长"
          },
          {
              "title": "蜡笔小新\tcrayon shin-chan",
              "flag": false,
              "value": "crayon shin-chan",
              "c_value": "蜡笔小新"
          },
          {
              "title": "灌篮高手\tslam dunk",
              "flag": false,
              "value": "slam dunk",
              "c_value": "灌篮高手"
          },
          {
              "title": "孙悟空\tsun wukong",
              "flag": false,
              "value": "sun wukong",
              "c_value": "孙悟空"
          },
          {
              "title": "女巫\twitch",
              "flag": false,
              "value": "witch",
              "c_value": "女巫"
          },
          {
              "title": "忍者\tninja",
              "flag": false,
              "value": "ninja",
              "c_value": "忍者"
          },
          {
              "title": "吸血鬼\tvampire",
              "flag": false,
              "value": "vampire",
              "c_value": "吸血鬼"
          },
          {
              "title": "骑士\tknight",
              "flag": false,
              "value": "knight",
              "c_value": "骑士"
          },
          {
              "title": "魔法少女\tmagical_girl",
              "flag": false,
              "value": "magical_girl",
              "c_value": "魔法少女"
          },
          {
              "title": "半兽人\torc",
              "flag": false,
              "value": "orc",
              "c_value": "半兽人"
          },
          {
              "title": "德鲁伊\tdruid",
              "flag": false,
              "value": "druid",
              "c_value": "德鲁伊"
          },
          {
              "title": "妖精\telf",
              "flag": false,
              "value": "elf",
              "c_value": "妖精"
          },
          {
              "title": "小精灵\tfairy",
              "flag": false,
              "value": "fairy",
              "c_value": "小精灵"
          },
          {
              "title": "兽人\tfurry",
              "flag": false,
              "value": "furry",
              "c_value": "兽人"
          },
          {
              "title": "美人鱼\tmermaid",
              "flag": false,
              "value": "mermaid",
              "c_value": "美人鱼"
          },
          {
              "title": "假面骑士\tkamen rider",
              "flag": false,
              "value": "kamen rider",
              "c_value": "假面骑士"
          },
          {
              "title": "魔导师\tmagister",
              "flag": false,
              "value": "magister",
              "c_value": "魔导师"
          },
          {
              "title": "蜘蛛侠\tspider-man",
              "flag": false,
              "value": "spider-man",
              "c_value": "蜘蛛侠"
          },
          {
              "title": "圣诞老人\tsanta alter",
              "flag": false,
              "value": "santa alter",
              "c_value": "圣诞老人"
          }
      ]
      },
      data_d: {
        "眉毛": [
            {
                "title": "浓眉\tthick eyebrows",
                "flag": false,
                "value": "thick eyebrows",
                "c_value": "浓眉"
            },
            {
                "title": "眉毛翘起\tcocked eyebrow",
                "flag": false,
                "value": "cocked eyebrow",
                "c_value": "眉毛翘起"
            },
            {
                "title": "短眉毛\tshort eyebrows",
                "flag": false,
                "value": "short eyebrows",
                "c_value": "短眉毛"
            },
            {
                "title": "V字眉\tv-shaped eyebrows",
                "flag": false,
                "value": "v-shaped eyebrows",
                "c_value": "V字眉"
            }
        ],
        "眼睛": [
          {
              "title": "空洞眼睛\tempty eyes",
              "flag": false,
              "value": "empty eyes",
              "c_value": "空洞眼睛"
          },
          {
              "title": "睁大眼睛\twide eyes",
              "flag": false,
              "value": "wide eyes",
              "c_value": "睁大眼睛"
          },
          {
              "title": "闭上一只眼\tone eye closed",
              "flag": false,
              "value": "one eye closed",
              "c_value": "闭上一只眼"
          },
          {
              "title": "半闭眼睛\thalf-closed eyes",
              "flag": false,
              "value": "half-closed eyes",
              "c_value": "半闭眼睛"
          },
          {
              "title": "渐变眼\tgradient_eyes",
              "flag": false,
              "value": "gradient_eyes",
              "c_value": "渐变眼"
          },
          {
              "title": "水汪汪大眼\taqua eyes",
              "flag": false,
              "value": "aqua eyes",
              "c_value": "水汪汪大眼"
          },
          {
              "title": "翻白眼\trolling eyes",
              "flag": false,
              "value": "rolling eyes",
              "c_value": "翻白眼"
          },
          {
              "title": "斗鸡眼\tcross-eyed",
              "flag": false,
              "value": "cross-eyed",
              "c_value": "斗鸡眼"
          },
          {
              "title": "猫眼\tslit pupils",
              "flag": false,
              "value": "slit pupils",
              "c_value": "猫眼"
          },
          {
              "title": "布满血丝的眼睛\tbloodshot eyes",
              "flag": false,
              "value": "bloodshot eyes",
              "c_value": "布满血丝的眼睛"
          },
          {
              "title": "发光眼睛\tglowing eyes",
              "flag": false,
              "value": "glowing eyes",
              "c_value": "发光眼睛"
          },
          {
              "title": "吊眼角\ttsurime",
              "flag": false,
              "value": "tsurime",
              "c_value": "吊眼角"
          },
          {
              "title": "垂眼角\ttareme",
              "flag": false,
              "value": "tareme",
              "c_value": "垂眼角"
          },
          {
              "title": "恶魔眼\tdevil eyes",
              "flag": false,
              "value": "devil eyes",
              "c_value": "恶魔眼"
          },
          {
              "title": "收缩的瞳孔\tconstricted pupils",
              "flag": false,
              "value": "constricted pupils",
              "c_value": "收缩的瞳孔"
          },
          {
              "title": "魔瞳\tdevil pupils",
              "flag": false,
              "value": "devil pupils",
              "c_value": "魔瞳"
          },
          {
              "title": "蛇瞳\tsnake pupils",
              "flag": false,
              "value": "snake pupils",
              "c_value": "蛇瞳"
          },
          {
              "title": "闪闪发光瞳\tpupils sparkling",
              "flag": false,
              "value": "pupils sparkling",
              "c_value": "闪闪发光瞳"
          },
          {
              "title": "花形瞳\tflower-shaped pupils",
              "flag": false,
              "value": "flower-shaped pupils",
              "c_value": "花形瞳"
          },
          {
              "title": "爱心瞳\theart-shaped pupils",
              "flag": false,
              "value": "heart-shaped pupils",
              "c_value": "爱心瞳"
          },
          {
              "title": "异色瞳\theterochromia",
              "flag": false,
              "value": "heterochromia",
              "c_value": "异色瞳"
          },
          {
              "title": "美瞳\tcolor contact lenses",
              "flag": false,
              "value": "color contact lenses",
              "c_value": "美瞳"
          },
          {
              "title": "长睫毛\tlongeyelashes",
              "flag": false,
              "value": "longeyelashes",
              "c_value": "长睫毛"
          },
          {
              "title": "彩色睫毛\tcolored eyelashes",
              "flag": false,
              "value": "colored eyelashes",
              "c_value": "彩色睫毛"
          },
          {
              "title": "眼下痣\tmole under eye",
              "flag": false,
              "value": "mole under eye",
              "c_value": "眼下痣"
          }
      ],
        "嘴巴": [
          {
              "title": "栗子嘴\tchestnut mouth",
              "flag": false,
              "value": "chestnut mouth",
              "c_value": "栗子嘴"
          },
          {
              "title": "厚嘴唇\tthick lips",
              "flag": false,
              "value": "thick lips",
              "c_value": "厚嘴唇"
          },
          {
              "title": "嘴唇浮肿\tpuffy lips",
              "flag": false,
              "value": "puffy lips",
              "c_value": "嘴唇浮肿"
          },
          {
              "title": "口红\tlipstick",
              "flag": false,
              "value": "lipstick",
              "c_value": "口红"
          },
          {
              "title": "心形嘴\theart-shaped mouth",
              "flag": false,
              "value": "heart-shaped mouth",
              "c_value": "心形嘴"
          },
          {
              "title": "嘟嘴\tpout",
              "flag": false,
              "value": "pout",
              "c_value": "嘟嘴"
          },
          {
              "title": "张嘴\topen mouth",
              "flag": false,
              "value": "open mouth",
              "c_value": "张嘴"
          },
          {
              "title": "闭嘴\tclosed mouth",
              "flag": false,
              "value": "closed mouth",
              "c_value": "闭嘴"
          },
          {
              "title": "猫咪嘴\t：3",
              "flag": false,
              "value": "：3",
              "c_value": "猫咪嘴"
          },
          {
              "title": "鲨鱼嘴\tshark mouth",
              "flag": false,
              "value": "shark mouth",
              "c_value": "鲨鱼嘴"
          },
          {
              "title": "吐舌头\t:p",
              "flag": false,
              "value": ":p",
              "c_value": "吐舌头"
          },
          {
              "title": "分开嘴唇\tparted lips",
              "flag": false,
              "value": "parted lips",
              "c_value": "分开嘴唇"
          },
          {
              "title": "嘴下痣\tmole under mouth",
              "flag": false,
              "value": "mole under mouth",
              "c_value": "嘴下痣"
          }
      ],
        "耳朵": [
          {
              "title": "动物耳朵\tfake animal ears",
              "flag": false,
              "value": "fake animal ears",
              "c_value": "动物耳朵"
          },
          {
              "title": "猫耳朵\tcat ears",
              "flag": false,
              "value": "cat ears",
              "c_value": "猫耳朵"
          },
          {
              "title": "狗耳朵\tdog ears",
              "flag": false,
              "value": "dog ears",
              "c_value": "狗耳朵"
          },
          {
              "title": "狐狸耳朵\tfox ears",
              "flag": false,
              "value": "fox ears",
              "c_value": "狐狸耳朵"
          },
          {
              "title": "兔子耳朵\tbunny ears",
              "flag": false,
              "value": "bunny ears",
              "c_value": "兔子耳朵"
          },
          {
              "title": "熊耳朵\tbear ears",
              "flag": false,
              "value": "bear ears",
              "c_value": "熊耳朵"
          }
      ],
        "胡子&牙": [
          {
              "title": "胡须\tbeard",
              "flag": false,
              "value": "beard",
              "c_value": "胡须"
          },
          {
              "title": "小胡子\tmustache",
              "flag": false,
              "value": "mustache",
              "c_value": "小胡子"
          },
          {
              "title": "山羊胡\tgoatee",
              "flag": false,
              "value": "goatee",
              "c_value": "山羊胡"
          },
          {
              "title": "长鬓角\tlong sideburns",
              "flag": false,
              "value": "long sideburns",
              "c_value": "长鬓角"
          },
          {
              "title": "尖牙\tfangs",
              "flag": false,
              "value": "fangs",
              "c_value": "尖牙"
          },
          {
              "title": "虎牙\tcanine teeth",
              "flag": false,
              "value": "canine teeth",
              "c_value": "虎牙"
          },
          {
              "title": "咬紧牙关\tclenched teeth",
              "flag": false,
              "value": "clenched teeth",
              "c_value": "咬紧牙关"
          }
        ]
      },
      data_e: {
        "表情": [
          {
              "title": "无表情\texpressionless",
              "flag": false,
              "value": "expressionless",
              "c_value": "无表情"
          },
          {
              "title": "脸色苍白\tturn pale",
              "flag": false,
              "value": "turn pale",
              "c_value": "脸色苍白"
          },
          {
              "title": "2D脸红\tblush stickers",
              "flag": false,
              "value": "blush stickers",
              "c_value": "2D脸红"
          },
          {
              "title": "脸红\tblush",
              "flag": false,
              "value": "blush",
              "c_value": "脸红"
          },
          {
              "title": "两眼发直\tblank stare",
              "flag": false,
              "value": "blank stare",
              "c_value": "两眼发直"
          },
          {
              "title": "青筋凸起\tanger vein",
              "flag": false,
              "value": "anger vein",
              "c_value": "青筋凸起"
          },
          {
              "title": "尴尬\tembarrassed",
              "flag": false,
              "value": "embarrassed",
              "c_value": "尴尬"
          },
          {
              "title": "傲慢\thubrael",
              "flag": false,
              "value": "hubrael",
              "c_value": "傲慢"
          },
          {
              "title": "郁闷\tdepressed",
              "flag": false,
              "value": "depressed",
              "c_value": "郁闷"
          },
          {
              "title": "畏缩\twince",
              "flag": false,
              "value": "wince",
              "c_value": "畏缩"
          },
          {
              "title": "烦恼\tkilesha",
              "flag": false,
              "value": "kilesha",
              "c_value": "烦恼"
          },
          {
              "title": "阴暗脸\tshaded face",
              "flag": false,
              "value": "shaded face",
              "c_value": "阴暗脸"
          },
          {
              "title": "疼痛\tpain",
              "flag": false,
              "value": "pain",
              "c_value": "疼痛"
          },
          {
              "title": "尖叫\tscreaming",
              "flag": false,
              "value": "screaming",
              "c_value": "尖叫"
          },
          {
              "title": "叹息\tsigh",
              "flag": false,
              "value": "sigh",
              "c_value": "叹息"
          },
          {
              "title": "紧张\tnervous",
              "flag": false,
              "value": "nervous",
              "c_value": "紧张"
          },
          {
              "title": "困惑\tconfused",
              "flag": false,
              "value": "confused",
              "c_value": "困惑"
          },
          {
              "title": "害怕\tscared",
              "flag": false,
              "value": "scared",
              "c_value": "害怕"
          },
          {
              "title": "喝醉\tdrunk",
              "flag": false,
              "value": "drunk",
              "c_value": "喝醉"
          },
          {
              "title": "哭\ttears",
              "flag": false,
              "value": "tears",
              "c_value": "哭"
          },
          {
              "title": "悲伤\tsad",
              "flag": false,
              "value": "sad",
              "c_value": "悲伤"
          },
          {
              "title": "生气\tangry",
              "flag": false,
              "value": "angry",
              "c_value": "生气"
          },
          {
              "title": "害羞\tnose blush",
              "flag": false,
              "value": "nose blush",
              "c_value": "害羞"
          },
          {
              "title": "严肃\tserious",
              "flag": false,
              "value": "serious",
              "c_value": "严肃"
          },
          {
              "title": "鄙夷\tjitome",
              "flag": false,
              "value": "jitome",
              "c_value": "鄙夷"
          },
          {
              "title": "疯狂\tcrazy",
              "flag": false,
              "value": "crazy",
              "c_value": "疯狂"
          },
          {
              "title": "黑化\tdark_persona",
              "flag": false,
              "value": "dark_persona",
              "c_value": "黑化"
          },
          {
              "title": "得意\tsmug",
              "flag": false,
              "value": "smug",
              "c_value": "得意"
          },
          {
              "title": "思考中\tthinking",
              "flag": false,
              "value": "thinking",
              "c_value": "思考中"
          },
          {
              "title": "扬眉\traised eyebrow",
              "flag": false,
              "value": "raised eyebrow",
              "c_value": "扬眉"
          },
          {
              "title": "轻皱眉\tlight frown",
              "flag": false,
              "value": "light frown",
              "c_value": "轻皱眉"
          },
          {
              "title": "皱眉\tfrown",
              "flag": false,
              "value": "frown",
              "c_value": "皱眉"
          },
          {
              "title": "调皮脸\tnaughty face",
              "flag": false,
              "value": "naughty face",
              "c_value": "调皮脸"
          },
          {
              "title": "做鬼脸\teyeid pull",
              "flag": false,
              "value": "eyeid pull",
              "c_value": "做鬼脸"
          },
          {
              "title": "流鼻血\tnosebleed",
              "flag": false,
              "value": "nosebleed",
              "c_value": "流鼻血"
          },
          {
              "title": "困\tsleepy",
              "flag": false,
              "value": "sleepy",
              "c_value": "困"
          },
          {
              "title": "眯眼\tzzz",
              "flag": false,
              "value": "zzz",
              "c_value": "眯眼"
          },
          {
              "title": "流口水\tdrooling",
              "flag": false,
              "value": "drooling",
              "c_value": "流口水"
          }
      ],
        "笑容": [
          {
              "title": "微笑\tlight smile",
              "flag": false,
              "value": "light smile",
              "c_value": "微笑"
          },
          {
              "title": "假笑\tfalse smile",
              "flag": false,
              "value": "false smile",
              "c_value": "假笑"
          },
          {
              "title": "挑逗笑容\tseductive smile",
              "flag": false,
              "value": "seductive smile",
              "c_value": "挑逗笑容"
          },
          {
              "title": "疯狂笑容\tcrazy smile",
              "flag": false,
              "value": "crazy smile",
              "c_value": "疯狂笑容"
          },
          {
              "title": "邪恶笑容\tevil smile",
              "flag": false,
              "value": "evil smile",
              "c_value": "邪恶笑容"
          },
          {
              "title": "单侧嘴角上扬\tsmirk",
              "flag": false,
              "value": "smirk",
              "c_value": "单侧嘴角上扬"
          },
          {
              "title": "诱人笑容\tseductive smile",
              "flag": false,
              "value": "seductive smile",
              "c_value": "诱人笑容"
          },
          {
              "title": "露齿笑\tgrin",
              "flag": false,
              "value": "grin",
              "c_value": "露齿笑"
          },
          {
              "title": "大笑\tlaughing",
              "flag": false,
              "value": "laughing",
              "c_value": "大笑"
          },
          {
              "title": "杯型笑脸\t:d",
              "flag": false,
              "value": ":d",
              "c_value": "杯型笑脸"
          }
        ]
      },
      data_f: {
        "长度": [
          {
              "title": "短发\tshort hair",
              "flag": false,
              "value": "short hair",
              "c_value": "短发"
          },
          {
              "title": "中发\tmedium hair",
              "flag": false,
              "value": "medium hair",
              "c_value": "中发"
          },
          {
              "title": "长发\tlong hair",
              "flag": false,
              "value": "long hair",
              "c_value": "长发"
          },
          {
              "title": "头发过肩\thair over shoulder",
              "flag": false,
              "value": "hair over shoulder",
              "c_value": "头发过肩"
          }
      ],
        "颜色": [
          {
              "title": "白发\twhite hair",
              "flag": false,
              "value": "white hair",
              "c_value": "白发"
          },
          {
              "title": "金发\tblonde hair",
              "flag": false,
              "value": "blonde hair",
              "c_value": "金发"
          },
          {
              "title": "银发\tsilver hair",
              "flag": false,
              "value": "silver hair",
              "c_value": "银发"
          },
          {
              "title": "灰发\tgrey hair",
              "flag": false,
              "value": "grey hair",
              "c_value": "灰发"
          },
          {
              "title": "棕发\tbrown hair",
              "flag": false,
              "value": "brown hair",
              "c_value": "棕发"
          },
          {
              "title": "黑发\tblack hair",
              "flag": false,
              "value": "black hair",
              "c_value": "黑发"
          },
          {
              "title": "紫发\tpurple hair",
              "flag": false,
              "value": "purple hair",
              "c_value": "紫发"
          },
          {
              "title": "红发\tred hair",
              "flag": false,
              "value": "red hair",
              "c_value": "红发"
          },
          {
              "title": "蓝发\tblue hair",
              "flag": false,
              "value": "blue hair",
              "c_value": "蓝发"
          },
          {
              "title": "绿发\tgreen hair",
              "flag": false,
              "value": "green hair",
              "c_value": "绿发"
          },
          {
              "title": "粉发\tpink hair",
              "flag": false,
              "value": "pink hair",
              "c_value": "粉发"
          },
          {
              "title": "橙发\torange hair",
              "flag": false,
              "value": "orange hair",
              "c_value": "橙发"
          },
          {
              "title": "挑染\tstreaked hair",
              "flag": false,
              "value": "streaked hair",
              "c_value": "挑染"
          },
          {
              "title": "彩发\tmulticolored hair",
              "flag": false,
              "value": "multicolored hair",
              "c_value": "彩发"
          },
          {
              "title": "彩虹发\trainbow-like hair",
              "flag": false,
              "value": "rainbow-like hair",
              "c_value": "彩虹发"
          }
      ],
        "刘海": [
            {
                "title": "刘海\tbangs",
                "flag": false,
                "value": "bangs",
                "c_value": "刘海"
            },
            {
                "title": "交叉刘海\tcrossed bang",
                "flag": false,
                "value": "crossed bang",
                "c_value": "交叉刘海"
            },
            {
                "title": "眉间刘海\thair between eye",
                "flag": false,
                "value": "hair between eye",
                "c_value": "眉间刘海"
            },
            {
                "title": "齐刘海\tblunt bangs",
                "flag": false,
                "value": "blunt bangs",
                "c_value": "齐刘海"
            },
            {
                "title": "斜刘海\tdiagonal bangs",
                "flag": false,
                "value": "diagonal bangs",
                "c_value": "斜刘海"
            },
            {
                "title": "不对称刘海\tasymmetrical bangs",
                "flag": false,
                "value": "asymmetrical bangs",
                "c_value": "不对称刘海"
            },
            {
                "title": "编织刘海\tbraided bangs",
                "flag": false,
                "value": "braided bangs",
                "c_value": "编织刘海"
            }
        ],
        "辫子": [
            {
                "title": "短马尾\tshort ponytail",
                "flag": false,
                "value": "短马尾\tshort ponytail",
                "c_value": "短马尾"
            },
            {
                "title": "侧马尾辫\tside ponytail",
                "flag": false,
                "value": "side ponytail",
                "c_value": "侧马尾辫"
            },
            {
                "title": "前马尾辫\tfront ponytail",
                "flag": false,
                "value": "front ponytail",
                "c_value": "前马尾辫"
            },
            {
                "title": "分裂马尾辫\tsplit ponytail",
                "flag": false,
                "value": "split ponytail",
                "c_value": "分裂马尾辫"
            },
            {
                "title": "低马尾辩\tlow twintails",
                "flag": false,
                "value": "low twintails",
                "c_value": "低马尾辩"
            },
            {
                "title": "短马尾辫\tshort twintails",
                "flag": false,
                "value": "short twintails",
                "c_value": "短马尾辫"
            },
            {
                "title": "侧边辫子\tside braid",
                "flag": false,
                "value": "side braid",
                "c_value": "侧边辫子"
            },
            {
                "title": "辫子\tbraid",
                "flag": false,
                "value": "braid",
                "c_value": "辫子"
            },
            {
                "title": "双辫子\ttwin braids",
                "flag": false,
                "value": "twin braids",
                "c_value": "双辫子"
            },
            {
                "title": "马尾辫\tponytail",
                "flag": false,
                "value": "ponytail",
                "c_value": "马尾辫"
            },
            {
                "title": "编织马尾\tbraided ponytail",
                "flag": false,
                "value": "braided ponytail",
                "c_value": "编织马尾"
            },
            {
                "title": "法式辫\tfrench braid",
                "flag": false,
                "value": "french braid",
                "c_value": "法式辫"
            },
            {
                "title": "麻花辫\ttwists",
                "flag": false,
                "value": "twists",
                "c_value": "麻花辫"
            },
            {
                "title": "高马尾\thigh ponytail",
                "flag": false,
                "value": "high ponytail",
                "c_value": "高马尾"
            }
        ],
        "发型": [
          {
              "title": "扎头发\ttied hair",
              "flag": false,
              "value": "tied hair",
              "c_value": "扎头发"
          },
          {
              "title": "单侧发髻\tsingle side bun",
              "flag": false,
              "value": "single side bun",
              "c_value": "单侧发髻"
          },
          {
              "title": "卷发\tcurly hair",
              "flag": false,
              "value": "curly hair",
              "c_value": "卷发"
          },
          {
              "title": "直发\tstraight hair",
              "flag": false,
              "value": "straight hair",
              "c_value": "直发"
          },
          {
              "title": "波浪头\twavy hair",
              "flag": false,
              "value": "wavy hair",
              "c_value": "波浪头"
          },
          {
              "title": "波波头\tbob hair",
              "flag": false,
              "value": "bob hair",
              "c_value": "波波头"
          },
          {
              "title": "侧分\tslicked-back",
              "flag": false,
              "value": "slicked-back",
              "c_value": "侧分"
          },
          {
              "title": "雷鬼头\tReggae hair",
              "flag": false,
              "value": "Reggae hair",
              "c_value": "雷鬼头"
          },
          {
              "title": "蓬巴杜发型\tpompadour",
              "flag": false,
              "value": "pompadour",
              "c_value": "蓬巴杜发型"
          },
          {
              "title": "莫西干头\tMohawk",
              "flag": false,
              "value": "Mohawk",
              "c_value": "莫西干头"
          },
          {
              "title": "锅盖头\tbowl cut",
              "flag": false,
              "value": "bowl cut",
              "c_value": "锅盖头"
          },
          {
              "title": "呆毛\tahoge",
              "flag": false,
              "value": "ahoge",
              "c_value": "呆毛"
          },
          {
              "title": "天线呆毛\tantenna hair",
              "flag": false,
              "value": "antenna hair",
              "c_value": "天线呆毛"
          },
          {
              "title": "心形呆毛\theart ahoge",
              "flag": false,
              "value": "heart ahoge",
              "c_value": "心形呆毛"
          },
          {
              "title": "公主卷\tdrill hair",
              "flag": false,
              "value": "drill hair",
              "c_value": "公主卷"
          },
          {
              "title": "翼状发\thair wings",
              "flag": false,
              "value": "hair wings",
              "c_value": "翼状发"
          },
          {
              "title": "蓬发\tdisheveled hair",
              "flag": false,
              "value": "disheveled hair",
              "c_value": "蓬发"
          },
          {
              "title": "凌乱发\tmessy hair",
              "flag": false,
              "value": "messy hair",
              "c_value": "凌乱发"
          },
          {
              "title": "露颈盘发\tchignon",
              "flag": false,
              "value": "chignon",
              "c_value": "露颈盘发"
          },
          {
              "title": "编织发髻\tbraided bun",
              "flag": false,
              "value": "braided bun",
              "c_value": "编织发髻"
          },
          {
              "title": "公主切\thime_cut",
              "flag": false,
              "value": "hime_cut",
              "c_value": "公主切"
          },
          {
              "title": "妹妹切\tbob cut",
              "flag": false,
              "value": "bob cut",
              "c_value": "妹妹切"
          },
          {
              "title": "刺猬头\tspiked hair",
              "flag": false,
              "value": "spiked hair",
              "c_value": "刺猬头"
          },
          {
              "title": "盘发\tupdo",
              "flag": false,
              "value": "updo",
              "c_value": "盘发"
          },
          {
              "title": "精灵短发\tpixie cut",
              "flag": false,
              "value": "pixie cut",
              "c_value": "精灵短发"
          },
          {
              "title": "长发绺\tdreadlocks",
              "flag": false,
              "value": "dreadlocks",
              "c_value": "长发绺"
          },
          {
              "title": "爆炸头\tafro",
              "flag": false,
              "value": "afro",
              "c_value": "爆炸头"
          },
          {
              "title": "秃头\tbald",
              "flag": false,
              "value": "bald",
              "c_value": "秃头"
          },
          {
              "title": "双丸子头\tdouble bun",
              "flag": false,
              "value": "double bun",
              "c_value": "双丸子头"
          },
          {
              "title": "美式寸头\tbuzz cut",
              "flag": false,
              "value": "buzz cut",
              "c_value": "美式寸头"
          },
          {
              "title": "大体积蓬松头发\tbig hair",
              "flag": false,
              "value": "big hair",
              "c_value": "大体积蓬松头发"
          },
          {
              "title": "闪亮的头发\tshiny hair",
              "flag": false,
              "value": "shiny hair",
              "c_value": "闪亮的头发"
          },
          {
              "title": "发光的头发\tglowing hair",
              "flag": false,
              "value": "glowing hair",
              "c_value": "发光的头发"
          },
          {
              "title": "眼睛间的头发\thair between eyes",
              "flag": false,
              "value": "hair between eyes",
              "c_value": "眼睛间的头发"
          },
          {
              "title": "撩到耳后\thair behind ear",
              "flag": false,
              "value": "hair behind ear",
              "c_value": "撩到耳后"
          }
      ]
      },
      data_g: {
        "发饰": [
          {
              "title": "头巾\thead scarf",
              "flag": false,
              "value": "head scarf",
              "c_value": "头巾"
          },
          {
              "title": "动物头巾\tanimal hood",
              "flag": false,
              "value": "animal hood",
              "c_value": "动物头巾"
          },
          {
              "title": "蝴蝶结发饰\thair bow",
              "flag": false,
              "value": "hair bow",
              "c_value": "蝴蝶结发饰"
          },
          {
              "title": "新月发饰\tcrescent hair ornament",
              "flag": false,
              "value": "crescent hair ornament",
              "c_value": "新月发饰"
          },
          {
              "title": "洛丽塔发饰\tlolita hairband",
              "flag": false,
              "value": "lolita hairband",
              "c_value": "洛丽塔发饰"
          },
          {
              "title": "羽毛发饰\tfeather hair ornament",
              "flag": false,
              "value": "feather hair ornament",
              "c_value": "羽毛发饰"
          },
          {
              "title": "头花\thair flower",
              "flag": false,
              "value": "hair flower",
              "c_value": "头花"
          },
          {
              "title": "发髻\thair bun",
              "flag": false,
              "value": "hair bun",
              "c_value": "发髻"
          },
          {
              "title": "发夹\thairclip",
              "flag": false,
              "value": "hairclip",
              "c_value": "发夹"
          },
          {
              "title": "发箍\thair scrunchie",
              "flag": false,
              "value": "hair scrunchie",
              "c_value": "发箍"
          },
          {
              "title": "发圈\thair rings",
              "flag": false,
              "value": "hair rings",
              "c_value": "发圈"
          },
          {
              "title": "发饰\thair ornament",
              "flag": false,
              "value": "hair ornament",
              "c_value": "发饰"
          },
          {
              "title": "发棒\thair stick",
              "flag": false,
              "value": "hair stick",
              "c_value": "发棒"
          },
          {
              "title": "心形发饰\theart hair ornament",
              "flag": false,
              "value": "heart hair ornament",
              "c_value": "心形发饰"
          }
      ],
        "首饰": [
          {
              "title": "手链\tbracelet",
              "flag": false,
              "value": "bracelet",
              "c_value": "手链"
          },
          {
              "title": "项圈\tchoker",
              "flag": false,
              "value": "choker",
              "c_value": "项圈"
          },
          {
              "title": "金属项圈\tmetal collar",
              "flag": false,
              "value": "metal collar",
              "c_value": "金属项圈"
          },
          {
              "title": "戒指\tring",
              "flag": false,
              "value": "ring",
              "c_value": "戒指"
          },
          {
              "title": "腕带\twristband",
              "flag": false,
              "value": "wristband",
              "c_value": "腕带"
          },
          {
              "title": "吊坠\tpendant",
              "flag": false,
              "value": "pendant",
              "c_value": "吊坠"
          },
          {
              "title": "胸针\tbrooch",
              "flag": false,
              "value": "brooch",
              "c_value": "胸针"
          },
          {
              "title": "圈形耳环\thoop earrings",
              "flag": false,
              "value": "hoop earrings",
              "c_value": "圈形耳环"
          },
          {
              "title": "手镯\tbangle",
              "flag": false,
              "value": "bangle",
              "c_value": "手镯"
          },
          {
              "title": "耳钉\tstud earrings",
              "flag": false,
              "value": "stud earrings",
              "c_value": "耳钉"
          },
          {
              "title": "旭日形首饰\tsunburst",
              "flag": false,
              "value": "sunburst",
              "c_value": "旭日形首饰"
          },
          {
              "title": "珍珠手链\tpearl bracelet",
              "flag": false,
              "value": "pearl bracelet",
              "c_value": "珍珠手链"
          },
          {
              "title": "耳坠\tdrop earrings",
              "flag": false,
              "value": "drop earrings",
              "c_value": "耳坠"
          },
          {
              "title": "木偶戒指\tpuppet rings",
              "flag": false,
              "value": "puppet rings",
              "c_value": "木偶戒指"
          },
          {
              "title": "胸花\tcorsage",
              "flag": false,
              "value": "corsage",
              "c_value": "胸花"
          },
          {
              "title": "蓝宝石胸针\tsapphire brooch",
              "flag": false,
              "value": "sapphire brooch",
              "c_value": "蓝宝石胸针"
          },
          {
              "title": "珠宝首饰\tjewelry",
              "flag": false,
              "value": "jewelry",
              "c_value": "珠宝首饰"
          },
          {
              "title": "项链\tnecklace",
              "flag": false,
              "value": "necklace",
              "c_value": "项链"
          }
      ],
        "装饰": [
          {
              "title": "丝带\tribbon",
              "flag": false,
              "value": "ribbon",
              "c_value": "丝带"
          },
          {
              "title": "丝带饰边\tribbon trim",
              "flag": false,
              "value": "ribbon trim",
              "c_value": "丝带饰边"
          },
          {
              "title": "蕾丝饰边\tlace trim",
              "flag": false,
              "value": "lace trim",
              "c_value": "蕾丝饰边"
          },
          {
              "title": "裙撑\tskirt lift",
              "flag": false,
              "value": "skirt lift",
              "c_value": "裙撑"
          },
          {
              "title": "护手\tgauntlets",
              "flag": false,
              "value": "gauntlets",
              "c_value": "护手"
          },
          {
              "title": "领巾\tneckerchief",
              "flag": false,
              "value": "neckerchief",
              "c_value": "领巾"
          },
          {
              "title": "红领巾\tred neckerchief",
              "flag": false,
              "value": "red neckerchief",
              "c_value": "红领巾"
          },
          {
              "title": "肩章\tpauldrons",
              "flag": false,
              "value": "pauldrons",
              "c_value": "肩章"
          },
          {
              "title": "臂带\tarm strap",
              "flag": false,
              "value": "arm strap",
              "c_value": "臂带"
          },
          {
              "title": "臂镯\tarmlet",
              "flag": false,
              "value": "armlet",
              "c_value": "臂镯"
          },
          {
              "title": "细肩带\tspaghetti strap",
              "flag": false,
              "value": "spaghetti strap",
              "c_value": "细肩带"
          },
          {
              "title": "般若面具\tPrajna in mask",
              "flag": false,
              "value": "Prajna in mask",
              "c_value": "般若面具"
          },
          {
              "title": "面纱\tveil",
              "flag": false,
              "value": "veil",
              "c_value": "面纱"
          },
          {
              "title": "新娘面纱\tbridal veil",
              "flag": false,
              "value": "bridal veil",
              "c_value": "新娘面纱"
          },
          {
              "title": "皇冠\ttiara",
              "flag": false,
              "value": "tiara",
              "c_value": "皇冠"
          },
          {
              "title": "迷你皇冠\tmini crown",
              "flag": false,
              "value": "mini crown",
              "c_value": "迷你皇冠"
          },
          {
              "title": "耳罩\tear covers",
              "flag": false,
              "value": "ear covers",
              "c_value": "耳罩"
          },
          {
              "title": "飞行员太阳镜\taviator sunglasses",
              "flag": false,
              "value": "aviator sunglasses",
              "c_value": "飞行员太阳镜"
          },
          {
              "title": "无边框眼镜\tsemi-rimless eyewear",
              "flag": false,
              "value": "semi-rimless eyewear",
              "c_value": "无边框眼镜"
          },
          {
              "title": "半无框眼镜\tsemi-rimless eyewear",
              "flag": false,
              "value": "semi-rimless eyewear",
              "c_value": "半无框眼镜"
          },
          {
              "title": "太阳镜\tsunglasses",
              "flag": false,
              "value": "sunglasses",
              "c_value": "太阳镜"
          },
          {
              "title": "风镜\tgoggles",
              "flag": false,
              "value": "goggles",
              "c_value": "风镜"
          },
          {
              "title": "独眼眼罩\teyepatch",
              "flag": false,
              "value": "eyepatch",
              "c_value": "独眼眼罩"
          },
          {
              "title": "黑色眼罩\tblack blindfold",
              "flag": false,
              "value": "black blindfold",
              "c_value": "黑色眼罩"
          },
          {
              "title": "铁棘\tmetal thorns",
              "flag": false,
              "value": "metal thorns",
              "c_value": "铁棘"
          },
          {
              "title": "光环\thalo",
              "flag": false,
              "value": "halo",
              "c_value": "光环"
          },
          {
              "title": "口罩\tmouth mask",
              "flag": false,
              "value": "mouth mask",
              "c_value": "口罩"
          },
          {
              "title": "创口贴\tbandaid hair ornament",
              "flag": false,
              "value": "bandaid hair ornament",
              "c_value": "创口贴"
          },
          {
              "title": "指甲油\tnail polish",
              "flag": false,
              "value": "nail polish",
              "c_value": "指甲油"
          },
          {
              "title": "玩偶关节\tdoll joints",
              "flag": false,
              "value": "doll joints",
              "c_value": "玩偶关节"
          },
          {
              "title": "机械义肢\tcybernetic prosthesis",
              "flag": false,
              "value": "cybernetic prosthesis",
              "c_value": "机械义肢"
          },
          {
              "title": "机械腿\tmechanical legs",
              "flag": false,
              "value": "mechanical legs",
              "c_value": "机械腿"
          },
          {
              "title": "沙滩巾\tbeach towel",
              "flag": false,
              "value": "beach towel",
              "c_value": "沙滩巾"
          },
          {
              "title": "雨披\tponcho",
              "flag": false,
              "value": "poncho",
              "c_value": "雨披"
          },
          {
              "title": "浓妆\tmake up",
              "flag": false,
              "value": "make up",
              "c_value": "浓妆"
          }
      ],
        "帽饰": [
          {
              "title": "棒球帽\tBaseball cap",
              "flag": false,
              "value": "Baseball cap",
              "c_value": "棒球帽"
          },
          {
              "title": "针织帽\tBeanie",
              "flag": false,
              "value": "Beanie",
              "c_value": "针织帽"
          },
          {
              "title": "拿破仑帽\tBicorne",
              "flag": false,
              "value": "Bicorne",
              "c_value": "拿破仑帽"
          },
          {
              "title": "太阳帽\tBoater hat",
              "flag": false,
              "value": "Boater hat",
              "c_value": "太阳帽"
          },
          {
              "title": "遮阳帽\tVisor cap",
              "flag": false,
              "value": "Visor cap",
              "c_value": "遮阳帽"
          },
          {
              "title": "圆顶礼帽\tBowler hat",
              "flag": false,
              "value": "Bowler hat",
              "c_value": "圆顶礼帽"
          },
          {
              "title": "报童帽\tCabbie hat",
              "flag": false,
              "value": "Cabbie hat",
              "c_value": "报童帽"
          },
          {
              "title": "渔夫帽\tBucket hat",
              "flag": false,
              "value": "Bucket hat",
              "c_value": "渔夫帽"
          },
          {
              "title": "侦探帽\tFedora",
              "flag": false,
              "value": "Fedora",
              "c_value": "侦探帽"
          },
          {
              "title": "牛仔帽\tCowboy hat",
              "flag": false,
              "value": "Cowboy hat",
              "c_value": "牛仔帽"
          },
          {
              "title": "厨师帽\tChef hat",
              "flag": false,
              "value": "Chef hat",
              "c_value": "厨师帽"
          },
          {
              "title": "军官帽\tMilitary hat",
              "flag": false,
              "value": "Military hat",
              "c_value": "军官帽"
          },
          {
              "title": "圣诞帽\tSanta hat",
              "flag": false,
              "value": "Santa hat",
              "c_value": "圣诞帽"
          },
          {
              "title": "派对帽\tParty hat",
              "flag": false,
              "value": "Party hat",
              "c_value": "派对帽"
          },
          {
              "title": "小丑帽\tJester cap",
              "flag": false,
              "value": "Jester cap",
              "c_value": "小丑帽"
          },
          {
              "title": "安全帽\tHardhat",
              "flag": false,
              "value": "Hardhat",
              "c_value": "安全帽"
          },
          {
              "title": "棒球头盔\tBaseball helmet",
              "flag": false,
              "value": "Baseball helmet",
              "c_value": "棒球头盔"
          },
          {
              "title": "橄榄球头盔\tFootball helmet",
              "flag": false,
              "value": "Football helmet",
              "c_value": "橄榄球头盔"
          },
          {
              "title": "动物头盔\tanimal helmet",
              "flag": false,
              "value": "animal helmet",
              "c_value": "动物头盔"
          },
          {
              "title": "女巫帽\twitch hat",
              "flag": false,
              "value": "witch hat",
              "c_value": "女巫帽"
          },
          {
              "title": "贝雷帽\tberet",
              "flag": false,
              "value": "beret",
              "c_value": "贝雷帽"
          },
          {
              "title": "鸭舌帽\tpeaked cap",
              "flag": false,
              "value": "peaked cap",
              "c_value": "鸭舌帽"
          },
          {
              "title": "草帽\tStraw hat",
              "flag": false,
              "value": "Straw hat",
              "c_value": "草帽"
          }
      ]
      },
      data_h: {
        "上装": [
          {
              "title": "过手袖\tsleeves_past_fingers",
              "flag": false,
              "value": "sleeves_past_fingers",
              "c_value": "过手袖"
          },
          {
              "title": "背心\ttank top",
              "flag": false,
              "value": "tank top",
              "c_value": "背心"
          },
          {
              "title": "白衬衫\twhite shirt",
              "flag": false,
              "value": "white shirt",
              "c_value": "白衬衫"
          },
          {
              "title": "水手衬衫\tsailor shirt",
              "flag": false,
              "value": "sailor shirt",
              "c_value": "水手衬衫"
          },
          {
              "title": "T恤\tT-shirt",
              "flag": false,
              "value": "T-shirt",
              "c_value": "T恤"
          },
          {
              "title": "毛衣\tsweater",
              "flag": false,
              "value": "sweater",
              "c_value": "毛衣"
          },
          {
              "title": "夏日长裙\tsummer dress",
              "flag": false,
              "value": "summer dress",
              "c_value": "夏日长裙"
          },
          {
              "title": "连帽衫\thoodie",
              "flag": false,
              "value": "hoodie",
              "c_value": "连帽衫"
          },
          {
              "title": "毛领\tfur trimmed colla",
              "flag": false,
              "value": "fur trimmed colla",
              "c_value": "毛领"
          },
          {
              "title": "兜帽斗篷\thooded cloak",
              "flag": false,
              "value": "hooded cloak",
              "c_value": "兜帽斗篷"
          },
          {
              "title": "夹克\tjacket",
              "flag": false,
              "value": "jacket",
              "c_value": "夹克"
          },
          {
              "title": "皮夹克\tleather jacket",
              "flag": false,
              "value": "leather jacket",
              "c_value": "皮夹克"
          },
          {
              "title": "探险家夹克\tsafari jacket",
              "flag": false,
              "value": "safari jacket",
              "c_value": "探险家夹克"
          },
          {
              "title": "兜帽\thood",
              "flag": false,
              "value": "hood",
              "c_value": "兜帽"
          },
          {
              "title": "牛仔夹克\tdenim jacket",
              "flag": false,
              "value": "denim jacket",
              "c_value": "牛仔夹克"
          },
          {
              "title": "高领夹克\tturtleneck jacket",
              "flag": false,
              "value": "turtleneck jacket",
              "c_value": "高领夹克"
          },
          {
              "title": "消防员夹克\tfirefighter jacket",
              "flag": false,
              "value": "firefighter jacket",
              "c_value": "消防员夹克"
          },
          {
              "title": "透明夹克\tsee-through jacket",
              "flag": false,
              "value": "see-through jacket",
              "c_value": "透明夹克"
          },
          {
              "title": "战壕大衣\ttrench coat",
              "flag": false,
              "value": "trench coat",
              "c_value": "战壕大衣"
          },
          {
              "title": "实验室外套\tlab coat",
              "flag": false,
              "value": "lab coat",
              "c_value": "实验室外套"
          },
          {
              "title": "羽绒服\tDown Jackets",
              "flag": false,
              "value": "Down Jackets",
              "c_value": "羽绒服"
          },
          {
              "title": "防弹盔甲\tbody armor",
              "flag": false,
              "value": "body armor",
              "c_value": "防弹盔甲"
          },
          {
              "title": "防弹衣\tflak jacket",
              "flag": false,
              "value": "flak jacket",
              "c_value": "防弹衣"
          },
          {
              "title": "大衣\tovercoat",
              "flag": false,
              "value": "overcoat",
              "c_value": "大衣"
          },
          {
              "title": "粗呢大衣\tduffel coat",
              "flag": false,
              "value": "duffel coat",
              "c_value": "粗呢大衣"
          }
      ],
        "服装": [
          {
              "title": "透视装\ttransparent clothes",
              "flag": false,
              "value": "transparent clothes",
              "c_value": "透视装"
          },
          {
              "title": "燕尾服\ttailcoat",
              "flag": false,
              "value": "tailcoat",
              "c_value": "燕尾服"
          },
          {
              "title": "女仆装\tVictoria black maid dress",
              "flag": false,
              "value": "Victoria black maid dress",
              "c_value": "女仆装"
          },
          {
              "title": "水手服\tsailor suit",
              "flag": false,
              "value": "sailor suit",
              "c_value": "水手服"
          },
          {
              "title": "学生服\tschool uniform",
              "flag": false,
              "value": "school uniform",
              "c_value": "学生服"
          },
          {
              "title": "职场制服\tbussiness suit",
              "flag": false,
              "value": "bussiness suit",
              "c_value": "职场制服"
          },
          {
              "title": "西装\tsuit",
              "flag": false,
              "value": "suit",
              "c_value": "西装"
          },
          {
              "title": "军装\tmilitary uniform",
              "flag": false,
              "value": "military uniform",
              "c_value": "军装"
          },
          {
              "title": "礼服\tlucency full dress",
              "flag": false,
              "value": "lucency full dress",
              "c_value": "礼服"
          },
          {
              "title": "汉服\thanfu",
              "flag": false,
              "value": "hanfu",
              "c_value": "汉服"
          },
          {
              "title": "旗袍\tcheongsam",
              "flag": false,
              "value": "cheongsam",
              "c_value": "旗袍"
          },
          {
              "title": "和服\tjapanses clothes",
              "flag": false,
              "value": "japanses clothes",
              "c_value": "和服"
          },
          {
              "title": "运动服\tsportswear",
              "flag": false,
              "value": "sportswear",
              "c_value": "运动服"
          },
          {
              "title": "工装服\tdungarees",
              "flag": false,
              "value": "dungarees",
              "c_value": "工装服"
          },
          {
              "title": "婚纱\twedding dress",
              "flag": false,
              "value": "wedding dress",
              "c_value": "婚纱"
          },
          {
              "title": "银色连衣裙\tsilvercleavage dress",
              "flag": false,
              "value": "silvercleavage dress",
              "c_value": "银色连衣裙"
          },
          {
              "title": "长袍\trobe",
              "flag": false,
              "value": "robe",
              "c_value": "长袍"
          },
          {
              "title": "围裙\tapron",
              "flag": false,
              "value": "apron",
              "c_value": "围裙"
          },
          {
              "title": "快餐制服\tfast food uniform",
              "flag": false,
              "value": "fast food uniform",
              "c_value": "快餐制服"
          },
          {
              "title": "JK制服\tJK",
              "flag": false,
              "value": "JK",
              "c_value": "JK制服"
          },
          {
              "title": "健身服\tgym_uniform",
              "flag": false,
              "value": "gym_uniform",
              "c_value": "健身服"
          },
          {
              "title": "巫女服\tmiko attire",
              "flag": false,
              "value": "miko attire",
              "c_value": "巫女服"
          },
          {
              "title": "海军陆战队服\tSWAT uniform",
              "flag": false,
              "value": "SWAT uniform",
              "c_value": "海军陆战队服"
          },
          {
              "title": "无袖连衣裙\tsleeveless dress",
              "flag": false,
              "value": "sleeveless dress",
              "c_value": "无袖连衣裙"
          },
          {
              "title": "雨衣\traincoat",
              "flag": false,
              "value": "raincoat",
              "c_value": "雨衣"
          },
          {
              "title": "机甲衣\tmech suit",
              "flag": false,
              "value": "mech suit",
              "c_value": "机甲衣"
          },
          {
              "title": "巫师法袍\twizard robe",
              "flag": false,
              "value": "wizard robe",
              "c_value": "巫师法袍"
          },
          {
              "title": "刺客装束\tassassin-style",
              "flag": false,
              "value": "assassin-style",
              "c_value": "刺客装束"
          }
      ],
        "下装": [
          {
              "title": "牛仔短裤\tdenim shorts",
              "flag": false,
              "value": "denim shorts",
              "c_value": "牛仔短裤"
          },
          {
              "title": "百褶裙\tpleated skirt",
              "flag": false,
              "value": "pleated skirt",
              "c_value": "百褶裙"
          },
          {
              "title": "热裤\tshort shorts",
              "flag": false,
              "value": "short shorts",
              "c_value": "热裤"
          },
          {
              "title": "铅笔裙\tpencil skirt",
              "flag": false,
              "value": "pencil skirt",
              "c_value": "铅笔裙"
          },
          {
              "title": "皮裙\tleather skirt",
              "flag": false,
              "value": "leather skirt",
              "c_value": "皮裙"
          },
          {
              "title": "黑色紧身裤\tblack leggings",
              "flag": false,
              "value": "black leggings",
              "c_value": "黑色紧身裤"
          },
          {
              "title": "和服下的裙子\tskirt under kimono",
              "flag": false,
              "value": "skirt under kimono",
              "c_value": "和服下的裙子"
          }
      ],
        "其他服装": [
          {
              "title": "褶边\tfrills",
              "flag": false,
              "value": "frills",
              "c_value": "褶边"
          },
          {
              "title": "花边\tlace",
              "flag": false,
              "value": "lace",
              "c_value": "花边"
          },
          {
              "title": "哥特风格\tgothic",
              "flag": false,
              "value": "gothic",
              "c_value": "哥特风格"
          },
          {
              "title": "洛丽塔风格\tlolita fashion",
              "flag": false,
              "value": "lolita fashion",
              "c_value": "洛丽塔风格"
          },
          {
              "title": "西部风格\twestern",
              "flag": false,
              "value": "western",
              "c_value": "西部风格"
          },
          {
              "title": "湿身\twet clothes",
              "flag": false,
              "value": "wet clothes",
              "c_value": "湿身"
          },
          {
              "title": "露单肩\toff_shoulder",
              "flag": false,
              "value": "off_shoulder",
              "c_value": "露单肩"
          },
          {
              "title": "露双肩\tbare_shoulders",
              "flag": false,
              "value": "bare_shoulders",
              "c_value": "露双肩"
          },
          {
              "title": "格子花纹\ttartan",
              "flag": false,
              "value": "tartan",
              "c_value": "格子花纹"
          },
          {
              "title": "横条花纹\tstriped",
              "flag": false,
              "value": "striped",
              "c_value": "横条花纹"
          },
          {
              "title": "披甲\tarmored skirt",
              "flag": false,
              "value": "armored skirt",
              "c_value": "披甲"
          },
          {
              "title": "盔甲\tarmor",
              "flag": false,
              "value": "armor",
              "c_value": "盔甲"
          },
          {
              "title": "金属盔甲\tmetal armor",
              "flag": false,
              "value": "metal armor",
              "c_value": "金属盔甲"
          },
          {
              "title": "狂战士铠甲\tberserker armor",
              "flag": false,
              "value": "berserker armor",
              "c_value": "狂战士铠甲"
          },
          {
              "title": "腰带\tbelt",
              "flag": false,
              "value": "belt",
              "c_value": "腰带"
          },
          {
              "title": "围巾\tscarf",
              "flag": false,
              "value": "scarf",
              "c_value": "围巾"
          },
          {
              "title": "披肩\tcape",
              "flag": false,
              "value": "cape",
              "c_value": "披肩"
          },
          {
              "title": "皮草披肩\tfur shawl",
              "flag": false,
              "value": "fur shawl",
              "c_value": "皮草披肩"
          }
      ]
      },
      data_i: {
        "鞋类": [
            {
                "title": "裸足\tbare_legs",
                "flag": false,
                "value": "bare_legs",
                "c_value": "裸足"
            },
            {
                "title": "靴子\tboots",
                "flag": false,
                "value": "boots",
                "c_value": "靴子"
            },
            {
                "title": "马丁靴\tknee boots",
                "flag": false,
                "value": "knee boots",
                "c_value": "马丁靴"
            },
            {
                "title": "脚踝靴\tankle boots",
                "flag": false,
                "value": "ankle boots",
                "c_value": "脚踝靴"
            },
            {
                "title": "系带靴\tcross-laced_footwear",
                "flag": false,
                "value": "cross-laced_footwear",
                "c_value": "系带靴"
            },
            {
                "title": "战斗靴\tcombat boots",
                "flag": false,
                "value": "combat boots",
                "c_value": "战斗靴"
            },
            {
                "title": "装甲靴\tarmored boots",
                "flag": false,
                "value": "armored boots",
                "c_value": "装甲靴"
            },
            {
                "title": "过膝靴\tknee boots",
                "flag": false,
                "value": "knee boots",
                "c_value": "过膝靴"
            },
            {
                "title": "防水橡胶靴\trubber boots",
                "flag": false,
                "value": "rubber boots",
                "c_value": "防水橡胶靴"
            },
            {
                "title": "皮靴\tleather boots",
                "flag": false,
                "value": "leather boots",
                "c_value": "皮靴"
            },
            {
                "title": "雪地靴\tsnow boots",
                "flag": false,
                "value": "snow boots",
                "c_value": "雪地靴"
            },
            {
                "title": "圣诞靴\tsanta boots",
                "flag": false,
                "value": "santa boots",
                "c_value": "圣诞靴"
            },
            {
                "title": "鞋子\tshoes",
                "flag": false,
                "value": "shoes",
                "c_value": "鞋子"
            },
            {
                "title": "厚底鞋\tplatform footwear",
                "flag": false,
                "value": "platform footwear",
                "c_value": "厚底鞋"
            },
            {
                "title": "尖头鞋\tpointy footwear",
                "flag": false,
                "value": "pointy footwear",
                "c_value": "尖头鞋"
            },
            {
                "title": "芭蕾舞鞋\tballet slippers",
                "flag": false,
                "value": "ballet slippers",
                "c_value": "芭蕾舞鞋"
            },
            {
                "title": "运动鞋\tsneakers",
                "flag": false,
                "value": "sneakers",
                "c_value": "运动鞋"
            },
            {
                "title": "旱冰鞋\troller skates",
                "flag": false,
                "value": "roller skates",
                "c_value": "旱冰鞋"
            },
            {
                "title": "溜冰鞋\tice skates",
                "flag": false,
                "value": "ice skates",
                "c_value": "溜冰鞋"
            },
            {
                "title": "钉鞋\tspiked shoes",
                "flag": false,
                "value": "spiked shoes",
                "c_value": "钉鞋"
            },
            {
                "title": "高跟鞋\thigh heels",
                "flag": false,
                "value": "high heels",
                "c_value": "高跟鞋"
            },
            {
                "title": "玛丽珍鞋\tmary janes",
                "flag": false,
                "value": "mary janes",
                "c_value": "玛丽珍鞋"
            },
            {
                "title": "乐福鞋\tloafers",
                "flag": false,
                "value": "loafers",
                "c_value": "乐福鞋"
            },
            {
                "title": "女式学生鞋\tuwabaki",
                "flag": false,
                "value": "uwabaki",
                "c_value": "女式学生鞋"
            },
            {
                "title": "凉鞋\tsandals",
                "flag": false,
                "value": "sandals",
                "c_value": "凉鞋"
            },
            {
                "title": "木屐\tgeta",
                "flag": false,
                "value": "geta",
                "c_value": "木屐"
            },
            {
                "title": "拖鞋\tslippers",
                "flag": false,
                "value": "slippers",
                "c_value": "拖鞋"
            },
            {
                "title": "人字拖\tflip-flops",
                "flag": false,
                "value": "flip-flops",
                "c_value": "人字拖"
            }
        ],
        "袜类": [
            {
                "title": "不穿袜子\tno socks",
                "flag": false,
                "value": "no socks",
                "c_value": "不穿袜子"
            },
            {
                "title": "短袜\tsocks",
                "flag": false,
                "value": "socks",
                "c_value": "短袜"
            },
            {
                "title": "日式厚底短袜\ttabi",
                "flag": false,
                "value": "tabi",
                "c_value": "日式厚底短袜"
            },
            {
                "title": "丝袜\tstockings",
                "flag": false,
                "value": "stockings",
                "c_value": "丝袜"
            },
            {
                "title": "圣诞袜\tchristmas stocking",
                "flag": false,
                "value": "christmas stocking",
                "c_value": "圣诞袜"
            },
            {
                "title": "暖腿袜\tleg warmers",
                "flag": false,
                "value": "leg warmers",
                "c_value": "暖腿袜"
            },
            {
                "title": "荷叶边袜子\tfrilled socks",
                "flag": false,
                "value": "frilled socks",
                "c_value": "荷叶边袜子"
            },
            {
                "title": "丝带边袜子\tribbon-trimmed legwear",
                "flag": false,
                "value": "ribbon-trimmed legwear",
                "c_value": "丝带边袜子"
            },
            {
                "title": "闪亮袜子\tshiny legwear",
                "flag": false,
                "value": "shiny legwear",
                "c_value": "闪亮袜子"
            },
            {
                "title": "褶边长筒袜\tfrilled thighhighs",
                "flag": false,
                "value": "frilled thighhighs",
                "c_value": "褶边长筒袜"
            },
            {
                "title": "过膝袜\tthighhighs",
                "flag": false,
                "value": "thighhighs",
                "c_value": "过膝袜"
            },
            {
                "title": "渔网袜\tfishnet stockings",
                "flag": false,
                "value": "fishnet stockings",
                "c_value": "渔网袜"
            },
            {
                "title": "堆堆袜\tloose socks",
                "flag": false,
                "value": "loose socks",
                "c_value": "堆堆袜"
            },
            {
                "title": "裤袜\tleggings",
                "flag": false,
                "value": "leggings",
                "c_value": "裤袜"
            },
            {
                "title": "蕾丝裤袜\tlace legwear",
                "flag": false,
                "value": "lace legwear",
                "c_value": "蕾丝裤袜"
            },
            {
                "title": "罗纹裤袜\tribbed legwear",
                "flag": false,
                "value": "ribbed legwear",
                "c_value": "罗纹裤袜"
            },
            {
                "title": "湿连裤袜\twet pantyhose",
                "flag": false,
                "value": "wet pantyhose",
                "c_value": "湿连裤袜"
            },
            {
                "title": "格子裤袜\tplaid legwear",
                "flag": false,
                "value": "plaid legwear",
                "c_value": "格子裤袜"
            },
            {
                "title": "透视裤袜\tsee-through legwear",
                "flag": false,
                "value": "see-through legwear",
                "c_value": "透视裤袜"
            },
            {
                "title": "连裤袜\tpantyhose",
                "flag": false,
                "value": "pantyhose",
                "c_value": "连裤袜"
            },
            {
                "title": "撕裂的连裤袜\ttorn pantyhose",
                "flag": false,
                "value": "torn pantyhose",
                "c_value": "撕裂的连裤袜"
            },
            {
                "title": "单腿连裤袜\tsingle leg pantyhose",
                "flag": false,
                "value": "single leg pantyhose",
                "c_value": "单腿连裤袜"
            },
            {
                "title": "荷叶边连裤袜\tfrilled pantyhose",
                "flag": false,
                "value": "frilled pantyhose",
                "c_value": "荷叶边连裤袜"
            },
            {
                "title": "柳丁吊袜带\tstudded garter belt",
                "flag": false,
                "value": "studded garter belt",
                "c_value": "柳丁吊袜带"
            },
            {
                "title": "吊袜带\tsock dangle",
                "flag": false,
                "value": "sock dangle",
                "c_value": "吊袜带"
            },
            {
                "title": "大腿系带\tthigh strap",
                "flag": false,
                "value": "thigh strap",
                "c_value": "大腿系带"
            },
            {
                "title": "腿部花边环\tleg_garter",
                "flag": false,
                "value": "leg_garter",
                "c_value": "腿部花边环"
            },
            {
                "title": "包扎腿\tbandaged leg",
                "flag": false,
                "value": "bandaged leg",
                "c_value": "包扎腿"
            }
        ]
      },
      data_j: {
        "尾巴": [
            {
                "title": "宝可梦尾巴\tpokemon tail",
                "flag": false,
                "value": "pokemon tail",
                "c_value": "宝可梦尾巴"
            },
            {
                "title": "皮卡丘尾巴\tpikachu tail",
                "flag": false,
                "value": "pikachu tail",
                "c_value": "皮卡丘尾巴"
            },
            {
                "title": "水獭尾巴\totter tail",
                "flag": false,
                "value": "otter tail",
                "c_value": "水獭尾巴"
            },
            {
                "title": "蝎尾\tscorpion tail",
                "flag": false,
                "value": "scorpion tail",
                "c_value": "蝎尾"
            },
            {
                "title": "鹿尾\tdeer tail",
                "flag": false,
                "value": "deer tail",
                "c_value": "鹿尾"
            },
            {
                "title": "黄鼠狼尾巴\tweasel tail",
                "flag": false,
                "value": "weasel tail",
                "c_value": "黄鼠狼尾巴"
            },
            {
                "title": "羊驼尾巴\talpaca tail",
                "flag": false,
                "value": "alpaca tail",
                "c_value": "羊驼尾巴"
            },
            {
                "title": "恐龙尾巴\tdinosaur tail",
                "flag": false,
                "value": "dinosaur tail",
                "c_value": "恐龙尾巴"
            },
            {
                "title": "企鹅尾巴\tpenguin tail",
                "flag": false,
                "value": "penguin tail",
                "c_value": "企鹅尾巴"
            },
            {
                "title": "羊尾巴\tsheep tail",
                "flag": false,
                "value": "sheep tail",
                "c_value": "羊尾巴"
            },
            {
                "title": "山羊尾巴\tgoat tail",
                "flag": false,
                "value": "goat tail",
                "c_value": "山羊尾巴"
            },
            {
                "title": "海狸尾巴\tbeaver tail",
                "flag": false,
                "value": "beaver tail",
                "c_value": "海狸尾巴"
            },
            {
                "title": "小熊猫尾巴\tred panda tail",
                "flag": false,
                "value": "red panda tail",
                "c_value": "小熊猫尾巴"
            },
            {
                "title": "豺尾巴\tjackal tail",
                "flag": false,
                "value": "jackal tail",
                "c_value": "豺尾巴"
            },
            {
                "title": "食蚁兽尾巴\tanteater tail",
                "flag": false,
                "value": "anteater tail",
                "c_value": "食蚁兽尾巴"
            },
            {
                "title": "土狼尾巴\taardwolf tail",
                "flag": false,
                "value": "aardwolf tail",
                "c_value": "土狼尾巴"
            },
            {
                "title": "猎豹尾巴\tpanther tail",
                "flag": false,
                "value": "panther tail",
                "c_value": "猎豹尾巴"
            },
            {
                "title": "熊猫尾巴\tpanda tail",
                "flag": false,
                "value": "panda tail",
                "c_value": "熊猫尾巴"
            },
            {
                "title": "天使尾巴\tAngel wings",
                "flag": false,
                "value": "Angel wings",
                "c_value": "天使尾巴"
            }
        ],
        "翅膀": [
            {
                "title": "蝴蝶翅膀\tButterfly wings",
                "flag": false,
                "value": "Butterfly wings",
                "c_value": "蝴蝶翅膀"
            },
            {
                "title": "昆虫翅膀\tinsect wings",
                "flag": false,
                "value": "insect wings",
                "c_value": "昆虫翅膀"
            },
            {
                "title": "蝙蝠翅膀\tBat wings",
                "flag": false,
                "value": "Bat wings",
                "c_value": "蝙蝠翅膀"
            },
            {
                "title": "鸟翼\tbird wings",
                "flag": false,
                "value": "bird wings",
                "c_value": "鸟翼"
            },
            {
                "title": "羽翼\tfeathered wings",
                "flag": false,
                "value": "feathered wings",
                "c_value": "羽翼"
            },
            {
                "title": "妖精翅膀\tFairy wings",
                "flag": false,
                "value": "Fairy wings",
                "c_value": "妖精翅膀"
            },
            {
                "title": "龙之翼\tDragon wings",
                "flag": false,
                "value": "Dragon wings",
                "c_value": "龙之翼"
            },
            {
                "title": "恶魔之翼\tDemon wings",
                "flag": false,
                "value": "Demon wings",
                "c_value": "恶魔之翼"
            },
            {
                "title": "火焰翅膀\tFiery wings",
                "flag": false,
                "value": "Fiery wings",
                "c_value": "火焰翅膀"
            },
            {
                "title": "机械翅膀\tMechanical wings",
                "flag": false,
                "value": "Mechanical wings",
                "c_value": "机械翅膀"
            },
            {
                "title": "冰翅\tice crystal texture",
                "flag": false,
                "value": "ice crystal texture",
                "c_value": "冰翅"
            },
            {
                "title": "冰火之翼\t((burning feathers)),(feathers_made_of_ice),(frozen feathers),(((ice and fire together)))",
                "flag": false,
                "value": "((burning feathers)),(feathers_made_of_ice),(frozen feathers),(((ice and fire together)))",
                "c_value": "冰火之翼"
            }
        ],
        "角": [
            {
                "title": "羚羊角\tantelope horns",
                "flag": false,
                "value": "antelope horns",
                "c_value": "羚羊角"
            },
            {
                "title": "山羊角\tgoat horns",
                "flag": false,
                "value": "goat horns",
                "c_value": "山羊角"
            },
            {
                "title": "羊角\tsheep horns",
                "flag": false,
                "value": "sheep horns",
                "c_value": "羊角"
            },
            {
                "title": "奶牛角\tcow horns",
                "flag": false,
                "value": "cow horns",
                "c_value": "奶牛角"
            },
            {
                "title": "公牛角\tox horns",
                "flag": false,
                "value": "ox horns",
                "c_value": "公牛角"
            },
            {
                "title": "鬼角\toni horns",
                "flag": false,
                "value": "oni horns",
                "c_value": "鬼角"
            },
            {
                "title": "断角\tbroken horn",
                "flag": false,
                "value": "broken horn",
                "c_value": "断角"
            },
            {
                "title": "机械角\tmechanical horns",
                "flag": false,
                "value": "mechanical horns",
                "c_value": "机械角"
            },
            {
                "title": "恶魔之角\tdemon horns",
                "flag": false,
                "value": "demon horns",
                "c_value": "恶魔之角"
            },
            {
                "title": "龙之角\tdragon horns",
                "flag": false,
                "value": "dragon horns",
                "c_value": "龙之角"
            }
        ]
      },
      data_k: {
        "姿态": [
            {
                "title": "侧身坐\tyokozuwari",
                "flag": false,
                "value": "yokozuwari",
                "c_value": "侧身坐"
            },
            {
                "title": "鸭子坐\tahirusuwari",
                "flag": false,
                "value": "ahirusuwari",
                "c_value": "鸭子坐"
            },
            {
                "title": "盘腿\tindian style",
                "flag": false,
                "value": "indian style",
                "c_value": "盘腿"
            },
            {
                "title": "跪着\tkneeling",
                "flag": false,
                "value": "kneeling",
                "c_value": "跪着"
            },
            {
                "title": "躬躯\tarched back",
                "flag": false,
                "value": "arched back",
                "c_value": "躬躯"
            },
            {
                "title": "膝枕\tlap pillow",
                "flag": false,
                "value": "lap pillow",
                "c_value": "膝枕"
            },
            {
                "title": "学猫叫\tpaw pose",
                "flag": false,
                "value": "paw pose",
                "c_value": "学猫叫"
            },
            {
                "title": "单膝跪地\tone knee",
                "flag": false,
                "value": "one knee",
                "c_value": "单膝跪地"
            },
            {
                "title": "蜷起身子侧躺\tfetal position",
                "flag": false,
                "value": "fetal position",
                "c_value": "蜷起身子侧躺"
            },
            {
                "title": "仰卧\ton back",
                "flag": false,
                "value": "on back",
                "c_value": "仰卧"
            },
            {
                "title": "俯卧\ton stomach",
                "flag": false,
                "value": "on stomach",
                "c_value": "俯卧"
            },
            {
                "title": "坐着\tsitting",
                "flag": false,
                "value": "sitting",
                "c_value": "坐着"
            },
            {
                "title": "屈膝抱腿坐\thugging own legs",
                "flag": false,
                "value": "hugging own legs",
                "c_value": "屈膝抱腿坐"
            },
            {
                "title": "立式跨骑\tupright straddle",
                "flag": false,
                "value": "upright straddle",
                "c_value": "立式跨骑"
            },
            {
                "title": "站着\tstanding",
                "flag": false,
                "value": "standing",
                "c_value": "站着"
            },
            {
                "title": "蹲着\tsquatting",
                "flag": false,
                "value": "squatting",
                "c_value": "蹲着"
            },
            {
                "title": "绑在十字架上\tcrucifixion",
                "flag": false,
                "value": "crucifixion",
                "c_value": "绑在十字架上"
            },
            {
                "title": "双腿缠绕\tleg lock",
                "flag": false,
                "value": "leg lock",
                "c_value": "双腿缠绕"
            },
            {
                "title": "四肢着地\tall fours",
                "flag": false,
                "value": "all fours",
                "c_value": "四肢着地"
            },
            {
                "title": "戴耳机\thand on headphones",
                "flag": false,
                "value": "hand on headphones",
                "c_value": "戴耳机"
            },
            {
                "title": "鬼姿势\tghost pose",
                "flag": false,
                "value": "ghost pose",
                "c_value": "鬼姿势"
            },
            {
                "title": "回头\tturning around",
                "flag": false,
                "value": "turning around",
                "c_value": "回头"
            },
            {
                "title": "歪头\thead tilt",
                "flag": false,
                "value": "head tilt",
                "c_value": "歪头"
            },
            {
                "title": "前倾\tleaning forward",
                "flag": false,
                "value": "leaning forward",
                "c_value": "前倾"
            }
        ],
        "手势": [
            {
                "title": "嘘手势\tshushing",
                "flag": false,
                "value": "shushing",
                "c_value": "嘘手势"
            },
            {
                "title": "翘大拇指\tthumbs up",
                "flag": false,
                "value": "thumbs up",
                "c_value": "翘大拇指"
            },
            {
                "title": "手放脑后\tarms behind head",
                "flag": false,
                "value": "arms behind head",
                "c_value": "手放脑后"
            },
            {
                "title": "手放身后\tarms behind back",
                "flag": false,
                "value": "arms behind back",
                "c_value": "手放身后"
            },
            {
                "title": "手插口袋\thand in pocket",
                "flag": false,
                "value": "hand in pocket",
                "c_value": "手插口袋"
            },
            {
                "title": "双手插口袋\thands in pocket",
                "flag": false,
                "value": "hands in pocket",
                "c_value": "双手插口袋"
            },
            {
                "title": "十指相扣\tinterlocked fingers",
                "flag": false,
                "value": "interlocked fingers",
                "c_value": "十指相扣"
            },
            {
                "title": "V字手势\tvictory pose",
                "flag": false,
                "value": "victory pose",
                "c_value": "V字手势"
            },
            {
                "title": "手在地板上\thand on floor",
                "flag": false,
                "value": "hand on floor",
                "c_value": "手在地板上"
            },
            {
                "title": "手在额头上\thand on forehead",
                "flag": false,
                "value": "hand on forehead",
                "c_value": "手在额头上"
            },
            {
                "title": "手在肚子上\thand on own stomach",
                "flag": false,
                "value": "hand on own stomach",
                "c_value": "手在肚子上"
            },
            {
                "title": "手在肩膀上\tarm over shoulder",
                "flag": false,
                "value": "arm over shoulder",
                "c_value": "手在肩膀上"
            },
            {
                "title": "手搭别人的腿\thand on another's leg",
                "flag": false,
                "value": "hand on another's leg",
                "c_value": "手搭别人的腿"
            },
            {
                "title": "手搭别人的腰\thand on another's waist",
                "flag": false,
                "value": "hand on another's waist",
                "c_value": "手搭别人的腰"
            },
            {
                "title": "双手合十\town hands clasped",
                "flag": false,
                "value": "own hands clasped",
                "c_value": "双手合十"
            },
            {
                "title": "翼展双臂\twide open arms",
                "flag": false,
                "value": "wide open arms",
                "c_value": "翼展双臂"
            },
            {
                "title": "手放嘴边\thand to mouth",
                "flag": false,
                "value": "hand to mouth",
                "c_value": "手放嘴边"
            },
            {
                "title": "手枪手势\tfinger gun",
                "flag": false,
                "value": "finger gun",
                "c_value": "手枪手势"
            },
            {
                "title": "猫爪手势\tcat pose",
                "flag": false,
                "value": "cat pose",
                "c_value": "猫爪手势"
            }
        ],
        "视线": [
            {
                "title": "远眺\tlooking afar",
                "flag": false,
                "value": "looking afar",
                "c_value": "远眺"
            },
            {
                "title": "照镜子\tlooking at mirror",
                "flag": false,
                "value": "looking at mirror",
                "c_value": "照镜子"
            },
            {
                "title": "看手机\tlooking at phone",
                "flag": false,
                "value": "looking at phone",
                "c_value": "看手机"
            },
            {
                "title": "看向别处\tlooking away",
                "flag": false,
                "value": "looking away",
                "c_value": "看向别处"
            },
            {
                "title": "透过刘海看\tvisible through hair",
                "flag": false,
                "value": "visible through hair",
                "c_value": "透过刘海看"
            },
            {
                "title": "透过眼镜看\tlooking over glasses",
                "flag": false,
                "value": "looking over glasses",
                "c_value": "透过眼镜看"
            },
            {
                "title": "面向观者\tlook at viewer",
                "flag": false,
                "value": "look at viewer",
                "c_value": "面向观者"
            },
            {
                "title": "靠近观者\tclose to viewer",
                "flag": false,
                "value": "close to viewer",
                "c_value": "靠近观者"
            },
            {
                "title": "动态角度\tdynamic angle",
                "flag": false,
                "value": "dynamic angle",
                "c_value": "动态角度"
            },
            {
                "title": "舞台角度\tdramatic angle",
                "flag": false,
                "value": "dramatic angle",
                "c_value": "舞台角度"
            },
            {
                "title": "凝视\tstare",
                "flag": false,
                "value": "stare",
                "c_value": "凝视"
            },
            {
                "title": "向上看\tlooking up",
                "flag": false,
                "value": "looking up",
                "c_value": "向上看"
            },
            {
                "title": "向下看\tlooking down",
                "flag": false,
                "value": "looking down",
                "c_value": "向下看"
            },
            {
                "title": "看向旁边\tlooking to the side",
                "flag": false,
                "value": "looking to the side",
                "c_value": "看向旁边"
            },
            {
                "title": "移开目光\tlooking away",
                "flag": false,
                "value": "looking away",
                "c_value": "移开目光"
            }
        ]
      },
      data_m: {
        "整体": [
            {
                "title": "嗅闻\tsmelling",
                "flag": false,
                "value": "smelling",
                "c_value": "嗅闻"
            },
            {
                "title": "公主抱\tprincess carry",
                "flag": false,
                "value": "princess carry",
                "c_value": "公主抱"
            },
            {
                "title": "拥抱\thug",
                "flag": false,
                "value": "hug",
                "c_value": "拥抱"
            },
            {
                "title": "背对背\tback-to-back",
                "flag": false,
                "value": "back-to-back",
                "c_value": "背对背"
            },
            {
                "title": "耶\tpeace symbol",
                "flag": false,
                "value": "peace symbol",
                "c_value": "耶"
            },
            {
                "title": "调整过膝袜\tadjusting_thighhigh",
                "flag": false,
                "value": "adjusting_thighhigh",
                "c_value": "调整过膝袜"
            },
            {
                "title": "抓住\tgrabbing",
                "flag": false,
                "value": "grabbing",
                "c_value": "抓住"
            },
            {
                "title": "战斗姿态\tfighting_stance",
                "flag": false,
                "value": "fighting_stance",
                "c_value": "战斗姿态"
            },
            {
                "title": "走\twalking",
                "flag": false,
                "value": "walking",
                "c_value": "走"
            },
            {
                "title": "跑\trunning",
                "flag": false,
                "value": "running",
                "c_value": "跑"
            },
            {
                "title": "跨坐\tstraddling",
                "flag": false,
                "value": "straddling",
                "c_value": "跨坐"
            },
            {
                "title": "跳\tjump",
                "flag": false,
                "value": "jump",
                "c_value": "跳"
            },
            {
                "title": "飞\tfly",
                "flag": false,
                "value": "fly",
                "c_value": "飞"
            },
            {
                "title": "靠墙\tagainst wall",
                "flag": false,
                "value": "against wall",
                "c_value": "靠墙"
            },
            {
                "title": "躺\tlie",
                "flag": false,
                "value": "lie",
                "c_value": "躺"
            },
            {
                "title": "从背后抱\thug from behind",
                "flag": false,
                "value": "hug from behind",
                "c_value": "从背后抱"
            },
            {
                "title": "遛狗\twalk a dog",
                "flag": false,
                "value": "walk a dog",
                "c_value": "遛狗"
            },
            {
                "title": "提裙\tskirt lift",
                "flag": false,
                "value": "skirt lift",
                "c_value": "提裙"
            },
            {
                "title": "泡温泉\thalf body under water",
                "flag": false,
                "value": "half body under water",
                "c_value": "泡温泉"
            },
            {
                "title": "骑马\thorse riding",
                "flag": false,
                "value": "horse riding",
                "c_value": "骑马"
            },
            {
                "title": "自拍\tselfie",
                "flag": false,
                "value": "selfie",
                "c_value": "自拍"
            },
            {
                "title": "一字马\tstanding split",
                "flag": false,
                "value": "standing split",
                "c_value": "一字马"
            },
            {
                "title": "敬礼\tsalute",
                "flag": false,
                "value": "salute",
                "c_value": "敬礼"
            },
            {
                "title": "祈祷\tpray",
                "flag": false,
                "value": "pray",
                "c_value": "祈祷"
            },
            {
                "title": "冥想\tdoing a meditation",
                "flag": false,
                "value": "doing a meditation",
                "c_value": "冥想"
            }
        ],
        "上半身": [
            {
                "title": "伸懒腰\tstretch",
                "flag": false,
                "value": "stretch",
                "c_value": "伸懒腰"
            },
            {
                "title": "托腮\tgill support",
                "flag": false,
                "value": "gill support",
                "c_value": "托腮"
            },
            {
                "title": "牵手\tholding hands",
                "flag": false,
                "value": "holding hands",
                "c_value": "牵手"
            },
            {
                "title": "单手叉腰\thand_on_hip",
                "flag": false,
                "value": "hand_on_hip",
                "c_value": "单手叉腰"
            },
            {
                "title": "双手叉腰\thands_on_hips",
                "flag": false,
                "value": "hands_on_hips",
                "c_value": "双手叉腰"
            },
            {
                "title": "招手\twaving",
                "flag": false,
                "value": "waving",
                "c_value": "招手"
            },
            {
                "title": "撮头发\thair scrunchie",
                "flag": false,
                "value": "hair scrunchie",
                "c_value": "撮头发"
            },
            {
                "title": "拉头发\thair_pull",
                "flag": false,
                "value": "hair_pull",
                "c_value": "拉头发"
            },
            {
                "title": "抓别人的头发\tgrabbing another's hair",
                "flag": false,
                "value": "grabbing another's hair",
                "c_value": "抓别人的头发"
            },
            {
                "title": "竖中指\tmiddle_finger",
                "flag": false,
                "value": "middle_finger",
                "c_value": "竖中指"
            },
            {
                "title": "弯腰\tbent over",
                "flag": false,
                "value": "bent over",
                "c_value": "弯腰"
            },
            {
                "title": "亲吻脸颊\tkissing cheek",
                "flag": false,
                "value": "kissing cheek",
                "c_value": "亲吻脸颊"
            },
            {
                "title": "亲吻额头\tkissing forehead",
                "flag": false,
                "value": "kissing forehead",
                "c_value": "亲吻额头"
            },
            {
                "title": "踮起脚尖吻\ttiptoe kiss",
                "flag": false,
                "value": "tiptoe kiss",
                "c_value": "踮起脚尖吻"
            },
            {
                "title": "头顶水果\tfruit on head",
                "flag": false,
                "value": "fruit on head",
                "c_value": "头顶水果"
            },
            {
                "title": "咬手套\tglove biting",
                "flag": false,
                "value": "glove biting",
                "c_value": "咬手套"
            },
            {
                "title": "脸贴脸\tcheek-to-cheek",
                "flag": false,
                "value": "cheek-to-cheek",
                "c_value": "脸贴脸"
            },
            {
                "title": "手牵手\thand on another's hand",
                "flag": false,
                "value": "hand on another's hand",
                "c_value": "手牵手"
            },
            {
                "title": "双手交叉\tcrossed arms",
                "flag": false,
                "value": "crossed arms",
                "c_value": "双手交叉"
            },
            {
                "title": "双手张开伸直\tspread arms",
                "flag": false,
                "value": "spread arms",
                "c_value": "双手张开伸直"
            },
            {
                "title": "挥动手臂\twaving arms",
                "flag": false,
                "value": "waving arms",
                "c_value": "挥动手臂"
            },
            {
                "title": "伸出手臂\toutstretched arm",
                "flag": false,
                "value": "outstretched arm",
                "c_value": "伸出手臂"
            },
            {
                "title": "用手臂支撑\tcarrying",
                "flag": false,
                "value": "carrying",
                "c_value": "用手臂支撑"
            },
            {
                "title": "搂着手臂\tarm hug",
                "flag": false,
                "value": "arm hug",
                "c_value": "搂着手臂"
            },
            {
                "title": "拿着\tholding",
                "flag": false,
                "value": "holding",
                "c_value": "拿着"
            },
            {
                "title": "拿着餐刀\tholding knife",
                "flag": false,
                "value": "holding knife",
                "c_value": "拿着餐刀"
            },
            {
                "title": "拿着枪\tholding gun",
                "flag": false,
                "value": "holding gun",
                "c_value": "拿着枪"
            },
            {
                "title": "拿着杯子\tholding cup",
                "flag": false,
                "value": "holding cup",
                "c_value": "拿着杯子"
            },
            {
                "title": "拿着食物\tholding food",
                "flag": false,
                "value": "holding food",
                "c_value": "拿着食物"
            },
            {
                "title": "拿着书\tholding book",
                "flag": false,
                "value": "holding book",
                "c_value": "拿着书"
            },
            {
                "title": "拿着魔杖\tholding wand",
                "flag": false,
                "value": "holding wand",
                "c_value": "拿着魔杖"
            },
            {
                "title": "打着伞\tholding umbrella",
                "flag": false,
                "value": "holding umbrella",
                "c_value": "打着伞"
            },
            {
                "title": "捧着花\tholding flower",
                "flag": false,
                "value": "holding flower",
                "c_value": "捧着花"
            },
            {
                "title": "拿着麦克风\tholding microphone",
                "flag": false,
                "value": "holding microphone",
                "c_value": "拿着麦克风"
            },
            {
                "title": "抱着物品\tobject hug",
                "flag": false,
                "value": "object hug",
                "c_value": "抱着物品"
            },
            {
                "title": "抱着心\tholding heart",
                "flag": false,
                "value": "holding heart",
                "c_value": "抱着心"
            }
        ]
      },
      data_n: {
        "四季朝暮": [
            {
                "title": "春天\tin spring",
                "flag": false,
                "value": "in spring",
                "c_value": "春天"
            },
            {
                "title": "夏天\tin summer",
                "flag": false,
                "value": "in summer",
                "c_value": "夏天"
            },
            {
                "title": "秋天\tin autumn",
                "flag": false,
                "value": "in autumn",
                "c_value": "秋天"
            },
            {
                "title": "冬天\tin winter",
                "flag": false,
                "value": "in winter",
                "c_value": "冬天"
            },
            {
                "title": "黄昏\tdusk",
                "flag": false,
                "value": "dusk",
                "c_value": "黄昏"
            },
            {
                "title": "夜晚\tnight",
                "flag": false,
                "value": "night",
                "c_value": "夜晚"
            },
            {
                "title": "秋景\t(autumn maple forest:1.3),(very few fallen leaves),(path)",
                "flag": false,
                "value": "(autumn maple forest:1.3),(very few fallen leaves),(path)",
                "c_value": "秋景"
            }
        ],
        "日月星辰": [
            {
                "title": "太阳\tsun",
                "flag": false,
                "value": "sun",
                "c_value": "太阳"
            },
            {
                "title": "落日\tsunset",
                "flag": false,
                "value": "sunset",
                "c_value": "落日"
            },
            {
                "title": "月亮\tmoon",
                "flag": false,
                "value": "moon",
                "c_value": "月亮"
            },
            {
                "title": "满月\tfull_moon",
                "flag": false,
                "value": "full_moon",
                "c_value": "满月"
            },
            {
                "title": "星星\tstars",
                "flag": false,
                "value": "stars",
                "c_value": "星星"
            },
            {
                "title": "天空\tsky",
                "flag": false,
                "value": "sky",
                "c_value": "天空"
            },
            {
                "title": "多云\tcloudy",
                "flag": false,
                "value": "cloudy",
                "c_value": "多云"
            },
            {
                "title": "雨天\train",
                "flag": false,
                "value": "rain",
                "c_value": "雨天"
            },
            {
                "title": "冰雪\tsnow,ice",
                "flag": false,
                "value": "snow,ice",
                "c_value": "冰雪"
            },
            {
                "title": "雪花\tsnowflakes",
                "flag": false,
                "value": "snowflakes",
                "c_value": "雪花"
            },
            {
                "title": "闪电\tlighting",
                "flag": false,
                "value": "lighting",
                "c_value": "闪电"
            },
            {
                "title": "彩虹\trainbow",
                "flag": false,
                "value": "rainbow",
                "c_value": "彩虹"
            },
            {
                "title": "流星雨\tmeteor shower",
                "flag": false,
                "value": "meteor shower",
                "c_value": "流星雨"
            },
            {
                "title": "宇宙\tuniverse",
                "flag": false,
                "value": "universe",
                "c_value": "宇宙"
            }
        ],
        "自然环境": [
            {
                "title": "大海\tsea",
                "flag": false,
                "value": "sea",
                "c_value": "大海"
            },
            {
                "title": "山丘\thills",
                "flag": false,
                "value": "hills",
                "c_value": "山丘"
            },
            {
                "title": "草地\tin a meadow",
                "flag": false,
                "value": "in a meadow",
                "c_value": "草地"
            },
            {
                "title": "海滩\ton the beach",
                "flag": false,
                "value": "on the beach",
                "c_value": "海滩"
            },
            {
                "title": "水中\tunderwater",
                "flag": false,
                "value": "underwater",
                "c_value": "水中"
            },
            {
                "title": "海边\tover the sea",
                "flag": false,
                "value": "over the sea",
                "c_value": "海边"
            },
            {
                "title": "树林\tgrove",
                "flag": false,
                "value": "grove",
                "c_value": "树林"
            },
            {
                "title": "沙漠\ton a desert",
                "flag": false,
                "value": "on a desert",
                "c_value": "沙漠"
            },
            {
                "title": "高原\tplateau",
                "flag": false,
                "value": "plateau",
                "c_value": "高原"
            },
            {
                "title": "悬崖\tcliff",
                "flag": false,
                "value": "cliff",
                "c_value": "悬崖"
            },
            {
                "title": "峡谷\tcanyon",
                "flag": false,
                "value": "canyon",
                "c_value": "峡谷"
            },
            {
                "title": "绿洲\toasis",
                "flag": false,
                "value": "oasis",
                "c_value": "绿洲"
            },
            {
                "title": "竹林\tbamboo forest",
                "flag": false,
                "value": "bamboo forest",
                "c_value": "竹林"
            },
            {
                "title": "冰川\tglacier",
                "flag": false,
                "value": "glacier",
                "c_value": "冰川"
            },
            {
                "title": "浮岛\tfloating island",
                "flag": false,
                "value": "floating island",
                "c_value": "浮岛"
            },
            {
                "title": "火山\tvolcano",
                "flag": false,
                "value": "volcano",
                "c_value": "火山"
            },
            {
                "title": "大草原\tsavanna",
                "flag": false,
                "value": "savanna",
                "c_value": "大草原"
            },
            {
                "title": "瀑布\twaterfall",
                "flag": false,
                "value": "waterfall",
                "c_value": "瀑布"
            },
            {
                "title": "溪流\tstream",
                "flag": false,
                "value": "stream",
                "c_value": "溪流"
            },
            {
                "title": "荒地\twasteland",
                "flag": false,
                "value": "wasteland",
                "c_value": "荒地"
            },
            {
                "title": "稻田\trice paddy",
                "flag": false,
                "value": "rice paddy",
                "c_value": "稻田"
            },
            {
                "title": "麦田\twheat field",
                "flag": false,
                "value": "wheat field",
                "c_value": "麦田"
            },
            {
                "title": "花田\tflower field",
                "flag": false,
                "value": "flower field",
                "c_value": "花田"
            },
            {
                "title": "花海\tflower sea",
                "flag": false,
                "value": "flower sea",
                "c_value": "花海"
            }
        ],
        "室内场景": [
            {
                "title": "室内\tindoor",
                "flag": false,
                "value": "indoor",
                "c_value": "室内"
            },
            {
                "title": "窗帘\tcurtain",
                "flag": false,
                "value": "curtain",
                "c_value": "窗帘"
            },
            {
                "title": "床\tbed",
                "flag": false,
                "value": "bed",
                "c_value": "床"
            },
            {
                "title": "浴室\tbathroom",
                "flag": false,
                "value": "bathroom",
                "c_value": "浴室"
            },
            {
                "title": "厕所隔间\ttoilet stall",
                "flag": false,
                "value": "toilet stall",
                "c_value": "厕所隔间"
            },
            {
                "title": "宅男房间\totaku room",
                "flag": false,
                "value": "otaku room",
                "c_value": "宅男房间"
            },
            {
                "title": "自助餐厅\tcafeteria",
                "flag": false,
                "value": "cafeteria",
                "c_value": "自助餐厅"
            },
            {
                "title": "教室\tclassroom",
                "flag": false,
                "value": "classroom",
                "c_value": "教室"
            },
            {
                "title": "俱乐部\tclubroom",
                "flag": false,
                "value": "clubroom",
                "c_value": "俱乐部"
            },
            {
                "title": "沙龙\tsalon",
                "flag": false,
                "value": "salon",
                "c_value": "沙龙"
            },
            {
                "title": "酒吧\tbar",
                "flag": false,
                "value": "bar",
                "c_value": "酒吧"
            },
            {
                "title": "居酒屋\tizakaya",
                "flag": false,
                "value": "izakaya",
                "c_value": "居酒屋"
            },
            {
                "title": "咖啡馆\tcafe",
                "flag": false,
                "value": "cafe",
                "c_value": "咖啡馆"
            },
            {
                "title": "面包店\tbakery",
                "flag": false,
                "value": "bakery",
                "c_value": "面包店"
            },
            {
                "title": "便利店\tconvenience store",
                "flag": false,
                "value": "convenience store",
                "c_value": "便利店"
            },
            {
                "title": "超市\tsupermarket",
                "flag": false,
                "value": "supermarket",
                "c_value": "超市"
            },
            {
                "title": "书店\tbookstore",
                "flag": false,
                "value": "bookstore",
                "c_value": "书店"
            },
            {
                "title": "药店\tpharmacy",
                "flag": false,
                "value": "pharmacy",
                "c_value": "药店"
            },
            {
                "title": "剧院\ttheater",
                "flag": false,
                "value": "theater",
                "c_value": "剧院"
            },
            {
                "title": "电影院\tmovie theater",
                "flag": false,
                "value": "movie theater",
                "c_value": "电影院"
            },
            {
                "title": "温室\tgreenhouse",
                "flag": false,
                "value": "greenhouse",
                "c_value": "温室"
            },
            {
                "title": "地库\tdungeon",
                "flag": false,
                "value": "dungeon",
                "c_value": "地库"
            },
            {
                "title": "健身房\tgym",
                "flag": false,
                "value": "gym",
                "c_value": "健身房"
            },
            {
                "title": "医务室\tinfirmary",
                "flag": false,
                "value": "infirmary",
                "c_value": "医务室"
            },
            {
                "title": "实验室\tlaboratory",
                "flag": false,
                "value": "laboratory",
                "c_value": "实验室"
            },
            {
                "title": "图书馆\tlibrary",
                "flag": false,
                "value": "library",
                "c_value": "图书馆"
            },
            {
                "title": "工作坊\tworkshop",
                "flag": false,
                "value": "workshop",
                "c_value": "工作坊"
            },
            {
                "title": "舞台\tstage",
                "flag": false,
                "value": "stage",
                "c_value": "舞台"
            },
            {
                "title": "法庭\tcourtroom",
                "flag": false,
                "value": "courtroom",
                "c_value": "法庭"
            }
        ],
        "城市建筑": [
            {
                "title": "城堡\tcastle",
                "flag": false,
                "value": "castle",
                "c_value": "城堡"
            },
            {
                "title": "城市\tcity",
                "flag": false,
                "value": "city",
                "c_value": "城市"
            },
            {
                "title": "水上乐园\twaterpark",
                "flag": false,
                "value": "waterpark",
                "c_value": "水上乐园"
            },
            {
                "title": "旋转木马\tcarousel",
                "flag": false,
                "value": "carousel",
                "c_value": "旋转木马"
            },
            {
                "title": "摩天轮\tferris wheel",
                "flag": false,
                "value": "ferris wheel",
                "c_value": "摩天轮"
            },
            {
                "title": "水族馆\taquarium",
                "flag": false,
                "value": "aquarium",
                "c_value": "水族馆"
            },
            {
                "title": "动物园\tzoo",
                "flag": false,
                "value": "zoo",
                "c_value": "动物园"
            },
            {
                "title": "保龄球馆\tbowling alley",
                "flag": false,
                "value": "bowling alley",
                "c_value": "保龄球馆"
            },
            {
                "title": "美术馆\tart gallery",
                "flag": false,
                "value": "art gallery",
                "c_value": "美术馆"
            },
            {
                "title": "博物馆\tmuseum",
                "flag": false,
                "value": "museum",
                "c_value": "博物馆"
            },
            {
                "title": "天文馆\tplanetarium",
                "flag": false,
                "value": "planetarium",
                "c_value": "天文馆"
            },
            {
                "title": "游泳池\tswimming pool",
                "flag": false,
                "value": "swimming pool",
                "c_value": "游泳池"
            },
            {
                "title": "体育场\tstadium",
                "flag": false,
                "value": "stadium",
                "c_value": "体育场"
            },
            {
                "title": "寺庙\ttemple",
                "flag": false,
                "value": "temple",
                "c_value": "寺庙"
            },
            {
                "title": "巴士车站\tbus stop",
                "flag": false,
                "value": "bus stop",
                "c_value": "巴士车站"
            },
            {
                "title": "火车站\ttrain station",
                "flag": false,
                "value": "train station",
                "c_value": "火车站"
            },
            {
                "title": "喷泉\tfountain",
                "flag": false,
                "value": "fountain",
                "c_value": "喷泉"
            },
            {
                "title": "游乐场\tplayground",
                "flag": false,
                "value": "playground",
                "c_value": "游乐场"
            },
            {
                "title": "市场摊位\tmarket stall",
                "flag": false,
                "value": "market stall",
                "c_value": "市场摊位"
            },
            {
                "title": "电话亭\tphone booth",
                "flag": false,
                "value": "phone booth",
                "c_value": "电话亭"
            },
            {
                "title": "铁轨\trailroad tracks",
                "flag": false,
                "value": "railroad tracks",
                "c_value": "铁轨"
            },
            {
                "title": "机场\tairport",
                "flag": false,
                "value": "airport",
                "c_value": "机场"
            },
            {
                "title": "隧道\ttunnel",
                "flag": false,
                "value": "tunnel",
                "c_value": "隧道"
            }
        ],
        "背景氛围": [
            {
                "title": "新年\tnew year",
                "flag": false,
                "value": "new year",
                "c_value": "新年"
            },
            {
                "title": "兔年\tyear of the rabbit",
                "flag": false,
                "value": "year of the rabbit",
                "c_value": "兔年"
            },
            {
                "title": "情人节\tvalentine",
                "flag": false,
                "value": "valentine",
                "c_value": "情人节"
            },
            {
                "title": "元宵节\tlantern festival",
                "flag": false,
                "value": "lantern festival",
                "c_value": "元宵节"
            },
            {
                "title": "夏日祭\tsummer festival",
                "flag": false,
                "value": "summer festival",
                "c_value": "夏日祭"
            },
            {
                "title": "七夕节\ttanabata",
                "flag": false,
                "value": "tanabata",
                "c_value": "七夕节"
            },
            {
                "title": "中秋节\tmid-autumn festival",
                "flag": false,
                "value": "mid-autumn festival",
                "c_value": "中秋节"
            },
            {
                "title": "万圣节\thalloween",
                "flag": false,
                "value": "halloween",
                "c_value": "万圣节"
            },
            {
                "title": "圣诞节\tchristmas",
                "flag": false,
                "value": "christmas",
                "c_value": "圣诞节"
            },
            {
                "title": "爆炸\texplosion",
                "flag": false,
                "value": "explosion",
                "c_value": "爆炸"
            },
            {
                "title": "蒸汽\twater vapor",
                "flag": false,
                "value": "water vapor",
                "c_value": "蒸汽"
            },
            {
                "title": "焰火\tfireworks",
                "flag": false,
                "value": "fireworks",
                "c_value": "焰火"
            },
            {
                "title": "落地窗\tceiling window",
                "flag": false,
                "value": "ceiling window",
                "c_value": "落地窗"
            },
            {
                "title": "彩色玻璃\tcolourful glass",
                "flag": false,
                "value": "colourful glass",
                "c_value": "彩色玻璃"
            },
            {
                "title": "染色玻璃\tstain glass",
                "flag": false,
                "value": "stain glass",
                "c_value": "染色玻璃"
            },
            {
                "title": "涂鸦墙\tGraffiti wall",
                "flag": false,
                "value": "Graffiti wall",
                "c_value": "涂鸦墙"
            },
            {
                "title": "马赛克背景\tmosaic background",
                "flag": false,
                "value": "mosaic background",
                "c_value": "马赛克背景"
            },
            {
                "title": "液体背景\tliquid background, Sputtered water",
                "flag": false,
                "value": "liquid background, Sputtered water",
                "c_value": "液体背景"
            },
            {
                "title": "魔法环\tmagic circles",
                "flag": false,
                "value": "magic circles",
                "c_value": "魔法环"
            },
            {
                "title": "荧光蘑菇森林\tfluorescent mushroom forests background",
                "flag": false,
                "value": "fluorescent mushroom forests background",
                "c_value": "荧光蘑菇森林"
            },
            {
                "title": "彩色泡泡\tcolorful bubble",
                "flag": false,
                "value": "colorful bubble",
                "c_value": "彩色泡泡"
            }
        ]
      },
      data_o: {
        "艺术风格": [
            {
                "title": "8bit游戏\t8 Bit Game",
                "flag": false,
                "value": "8 Bit Game",
                "c_value": "8bit游戏"
            },
            {
                "title": "80年代动画\t1980s anime",
                "flag": false,
                "value": "1980s anime",
                "c_value": "80年代动画"
            },
            {
                "title": "迪士尼电影\tdisney movie",
                "flag": false,
                "value": "disney movie",
                "c_value": "迪士尼电影"
            },
            {
                "title": "哥特摇滚\tgoth",
                "flag": false,
                "value": "goth",
                "c_value": "哥特摇滚"
            },
            {
                "title": "80年代电影\t80s movie",
                "flag": false,
                "value": "80s movie",
                "c_value": "80年代电影"
            },
            {
                "title": "泡泡龙\tbubble bobble",
                "flag": false,
                "value": "bubble bobble",
                "c_value": "泡泡龙"
            },
            {
                "title": "皮克斯动画\tstyle of Pixar",
                "flag": false,
                "value": "style of Pixar",
                "c_value": "皮克斯动画"
            },
            {
                "title": "宝丽来艺术\tPolaroid art",
                "flag": false,
                "value": "Polaroid art",
                "c_value": "宝丽来艺术"
            },
            {
                "title": "万花筒摄影\tKaleidoscope Photography",
                "flag": false,
                "value": "Kaleidoscope Photography",
                "c_value": "万花筒摄影"
            },
            {
                "title": "欧泊渲染\topal render",
                "flag": false,
                "value": "opal render",
                "c_value": "欧泊渲染"
            },
            {
                "title": "色谱图\tchemigram",
                "flag": false,
                "value": "chemigram",
                "c_value": "色谱图"
            },
            {
                "title": "吉卜力风格\tStudio Ghibli",
                "flag": false,
                "value": "Studio Ghibli",
                "c_value": "吉卜力风格"
            },
            {
                "title": "梦幻\tdreamlike",
                "flag": false,
                "value": "dreamlike",
                "c_value": "梦幻"
            },
            {
                "title": "签绘风格\tfaux traditional media",
                "flag": false,
                "value": "faux traditional media",
                "c_value": "签绘风格"
            },
            {
                "title": "原神冲击\tgenshin impact",
                "flag": false,
                "value": "genshin impact",
                "c_value": "原神冲击"
            },
            {
                "title": "碧蓝航线\tazur lane",
                "flag": false,
                "value": "azur lane",
                "c_value": "碧蓝航线"
            },
            {
                "title": "舰队收藏\tkantai collection",
                "flag": false,
                "value": "kantai collection",
                "c_value": "舰队收藏"
            },
            {
                "title": "边缘行者\trebecca (cyberpunk)",
                "flag": false,
                "value": "rebecca (cyberpunk)",
                "c_value": "边缘行者"
            },
            {
                "title": "电锯人\tchainsaw man",
                "flag": false,
                "value": "chainsaw man",
                "c_value": "电锯人"
            },
            {
                "title": "魔法旋涡\tMagic Vortex",
                "flag": false,
                "value": "Magic Vortex",
                "c_value": "魔法旋涡"
            },
            {
                "title": "柴油朋克\tdieselpunk",
                "flag": false,
                "value": "dieselpunk",
                "c_value": "柴油朋克"
            },
            {
                "title": "四格\t4koma",
                "flag": false,
                "value": "4koma",
                "c_value": "四格"
            },
            {
                "title": "杂志扫描\tmagazine scan",
                "flag": false,
                "value": "magazine scan",
                "c_value": "杂志扫描"
            },
            {
                "title": "专辑封面\talbum cover",
                "flag": false,
                "value": "album cover",
                "c_value": "专辑封面"
            },
            {
                "title": "线条变粗\tlineart",
                "flag": false,
                "value": "lineart",
                "c_value": "线条变粗"
            },
            {
                "title": "蒸汽波\tsynthwave",
                "flag": false,
                "value": "synthwave",
                "c_value": "蒸汽波"
            },
            {
                "title": "洛可可\t(illustration),(paper figure),(lococo),((impasto)),(shiny skin)",
                "flag": false,
                "value": "(illustration),(paper figure),(lococo),((impasto)),(shiny skin)",
                "c_value": "洛可可"
            }
        ],
        "艺术类型": [
            {
                "title": "单色图片\tmonochrome",
                "flag": false,
                "value": "monochrome",
                "c_value": "单色图片"
            },
            {
                "title": "拼贴艺术\tCollage",
                "flag": false,
                "value": "Collage",
                "c_value": "拼贴艺术"
            },
            {
                "title": "彩色玻璃工艺\tDalle de verre",
                "flag": false,
                "value": "Dalle de verre",
                "c_value": "彩色玻璃工艺"
            },
            {
                "title": "像素画\tpixel art",
                "flag": false,
                "value": "pixel art",
                "c_value": "像素画"
            },
            {
                "title": "瓷画\tEncaustic painting",
                "flag": false,
                "value": "Encaustic painting",
                "c_value": "瓷画"
            },
            {
                "title": "水墨画\tInk wash painting",
                "flag": false,
                "value": "Ink wash painting",
                "c_value": "水墨画"
            },
            {
                "title": "铜版雕刻\tMezzotint",
                "flag": false,
                "value": "Mezzotint",
                "c_value": "铜版雕刻"
            },
            {
                "title": "剪影\tsilhouette",
                "flag": false,
                "value": "silhouette",
                "c_value": "剪影"
            },
            {
                "title": "插画\tillustration",
                "flag": false,
                "value": "illustration",
                "c_value": "插画"
            },
            {
                "title": "水彩画\t(((ink))), ((watercolor))",
                "flag": false,
                "value": "(((ink))), ((watercolor))",
                "c_value": "水彩画"
            },
            {
                "title": "浮世绘\tillustration,(((ukiyoe))),((sketch)),((japanese_art))",
                "flag": false,
                "value": "illustration,(((ukiyoe))),((sketch)),((japanese_art))",
                "c_value": "浮世绘"
            },
            {
                "title": "中国风\t((wash painting)),((ink splashing)),((color splashing)),((((dyeing)))),((chinese style))",
                "flag": false,
                "value": "((wash painting)),((ink splashing)),((color splashing)),((((dyeing)))),((chinese style))",
                "c_value": "中国风"
            },
            {
                "title": "油画\t((dyeing)),((oil painting)),((impasto))",
                "flag": false,
                "value": "((dyeing)),((oil painting)),((impasto))",
                "c_value": "油画"
            },
            {
                "title": "黑白草图\t(posing sketch), (monochrome)",
                "flag": false,
                "value": "(posing sketch), (monochrome)",
                "c_value": "黑白草图"
            },
            {
                "title": "手画草稿\tsketch",
                "flag": false,
                "value": "sketch",
                "c_value": "手画草稿"
            },
            {
                "title": "铅笔速写\t(monochrome), (gray scale), (pencil sketch lines",
                "flag": false,
                "value": "(monochrome), (gray scale), (pencil sketch lines",
                "c_value": "铅笔速写"
            },
            {
                "title": "彩铅画\t(watercolor pencil)",
                "flag": false,
                "value": "(watercolor pencil)",
                "c_value": "彩铅画"
            }
        ],
        "艺术派系": [
            {
                "title": "新艺术主义\tart nouveau",
                "flag": false,
                "value": "art nouveau",
                "c_value": "新艺术主义"
            },
            {
                "title": "古典主义\tclassicism",
                "flag": false,
                "value": "classicism",
                "c_value": "古典主义"
            },
            {
                "title": "未来主义\tfuturism",
                "flag": false,
                "value": "futurism",
                "c_value": "未来主义"
            },
            {
                "title": "达达主义\tDadaism",
                "flag": false,
                "value": "Dadaism",
                "c_value": "达达主义"
            },
            {
                "title": "抽象艺术\tabstract art",
                "flag": false,
                "value": "abstract art",
                "c_value": "抽象艺术"
            },
            {
                "title": "ASCII艺术\tASCII art",
                "flag": false,
                "value": "ASCII art",
                "c_value": "ASCII艺术"
            }
        ],
        "艺术家风格": [
            {
                "title": "穆夏风格\talphonse mucha",
                "flag": false,
                "value": "alphonse mucha",
                "c_value": "穆夏风格"
            },
            {
                "title": "莫奈风格\tMonet style",
                "flag": false,
                "value": "Monet style",
                "c_value": "莫奈风格"
            }
        ],
        "光照": [
            {
                "title": "轮廓光\trim light",
                "flag": false,
                "value": "rim light",
                "c_value": "轮廓光"
            },
            {
                "title": "体积光\tVolumetric Lighting",
                "flag": false,
                "value": "Volumetric Lighting",
                "c_value": "体积光"
            },
            {
                "title": "霓虹灯\tglowing neon lights",
                "flag": false,
                "value": "glowing neon lights",
                "c_value": "霓虹灯"
            },
            {
                "title": "电影级光照\tCinematic Lighting",
                "flag": false,
                "value": "Cinematic Lighting",
                "c_value": "电影级光照"
            },
            {
                "title": "透镜光晕\tlens flare",
                "flag": false,
                "value": "lens flare",
                "c_value": "透镜光晕"
            },
            {
                "title": "金属光泽\tmetallic luster",
                "flag": false,
                "value": "metallic luster",
                "c_value": "金属光泽"
            },
            {
                "title": "氛围光照\tmoody lighting",
                "flag": false,
                "value": "moody lighting",
                "c_value": "氛围光照"
            },
            {
                "title": "丁达尔效应\tTyndall effect",
                "flag": false,
                "value": "Tyndall effect",
                "c_value": "丁达尔效应"
            },
            {
                "title": "漏光光效\tlight leaks",
                "flag": false,
                "value": "light leaks",
                "c_value": "漏光光效"
            },
            {
                "title": "背景光\tbackground light",
                "flag": false,
                "value": "background light",
                "c_value": "背景光"
            },
            {
                "title": "自然光\tavailable light",
                "flag": false,
                "value": "available light",
                "c_value": "自然光"
            }
        ]
      }

	
    }
  },
  methods : {
    dialogCloseMed(){
        this.status = 'off' ;
        this.statusFlag = false ;
    },
    offStatus(){
        this.status = 'off' ;
        this.statusFlag = false ;
    },
    computedstatus(){
        if( this.status == 'on' ){
            return  true ;
        } else {
            return false  ;
        }
    },
    openStatus(){
        this.status = 'on';
        this.statusFlag = true ;
    },
    valueItemClick( curdata ,   key , valueIdx ){

      this[ curdata ][ key ][  valueIdx ].flag =  !this[ curdata ][ key ][  valueIdx ].flag


      if( this.promptLanguage == "中文" ){
        this.$emit('ClickPrompt', this[ curdata ][ key ][  valueIdx ].c_value ,  this[ curdata ][ key ][  valueIdx ].flag  );

      } else {
        this.$emit('ClickPrompt', this[ curdata ][ key ][  valueIdx ].value ,  this[ curdata ][ key ][  valueIdx ].flag  );
      }
    } ,
        // 计算属性的 getter
    selectedData ( val ){
      let arr = [] ;
      let dataname = "data_" + val ; 
      for (const key in this[dataname]  ) {
        this[dataname][key].forEach(ele => {
          if( ele.flag ) {
            if( !this.isEnglish  ){
              arr.push( ele.c_value )
            } else {
              arr.push( ele.value )
            }
            
          }
        });
      }
      return arr ; 
    } ,
    // languageChange( val ){
    //   this.$emit('update:dialogCarouselVisible',  this.promptLanguage != '中文' ) // 传递更新数值
    //   console.log( val )
    // },
  },
  computed: {
    formVuex: {
      get(){
        // 存储位置： store.state.{模块名,在store/index.js中module下的}.{state中定义的属性}
        return this.$store.state.textImage.form
      },
      set(newVal){
        this.formVuex  = newVal;
      }
    },

    imgFormVuex : {
      get(){
        // 存储位置： store.state.{模块名,在store/index.js中module下的}.{state中定义的属性}
        return this.$store.state.imageImage.form
      },
      set(newVal){
        this.imgFormVuex  = newVal;
      }
    },
    // isEnglish : {
    //   get(){
    //     return this.promptLanguage != '中文'
    //   },
    //   set(newVal){
    //     let str = newVal ? "英文" : "中文"
    //     this.$emit('update:promptLanguage',  str )
    //   }
    // }

  },
  watch: {
    promptArr: {
      deep: true,  // 深度监听
      handler(newVal,oldVal) {
        let arr = [  "er" , "a" , "b" , "c" , "d" , "e" , "f" , "g" , "h" , "i" , "j" , "k" , "m" , "n" , "o" ] 
        arr.forEach( ele => {
          let dataname = "data_" + ele ;
          for (const key in this[ dataname ]   ) {
            this[ dataname ][key].forEach( ele => {
              if( ele.flag && newVal.indexOf(ele.value) == -1 && newVal.indexOf(ele.c_value) == -1  ) {
                ele.flag = false ;
              }
            })
          }
        });
      }
    } ,

    'formVuex.model'(newVal, oldVal) {
        if( newVal == 'anythingV3_fp16.ckpt' ){

        } else {
          this.activeName = "a"  
        }
    } ,
    closePrompt (newVal){
      if( newVal ){
        this.status  = "off"
      }
    } ,
    promptLanguage( newVal ){
        let arr = [  "er" , "a" , "b" , "c" , "d" , "e" , "f" , "g" , "h" , "i" , "j" , "k" , "m" , "n" , "o" ] 
        arr.forEach( ele => {
          let dataname = "data_" + ele ;
          for (const key in this[ dataname ]   ) {
            this[ dataname ][key].forEach( ele => {
              if(  newVal == "中文" ){ 
                if( this.promptArr.indexOf( ele.value ) > -1 ){  //找到了
                  this.promptArr.splice( this.promptArr.indexOf( ele.value ) , 1 , ele.c_value )
                }
              } else if( newVal == "英文" ){
                if( this.promptArr.indexOf( ele.c_value ) > -1 ){  //找到了
                  this.promptArr.splice( this.promptArr.indexOf( ele.c_value ) , 1 , ele.value )
                }
              }
            })
          }   
        })
        this.$emit('ChangePrompt', this.promptArr );
    }
  }


}
</script>

<style lang="scss" scoped>
.prompt {
  .off {
    width: 114px;
    height: 30px;
    background: #0B0B1F;
    border-radius: 14px;
    border: 1px solid #006FFF;
    box-sizing: border-box;
    font-size: 14px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #006FFF;
    line-height: 28px;
  }

  @keyframes fade-in {
    0%   {opacity: 0;}
    25%  {opacity: 0;}
    50%  {opacity: 0;}
    75%  {opacity: 0.3;}
    100% {opacity: 1;}
  }
  .on {
    border-radius: 10px;
    position: absolute;
    left: 0; 
    right: 0; 
    z-index: 9999999;
    // bottom: 0;
    background-color: #1B1D2E;
    // height: 400px;
    // transition: height .1s linear;
    opacity: 1;
    animation: fade-in .2s ease;

    padding: 12px 14px;
    box-sizing: border-box;
    .line {
      align-items: center;
      font-size: 16px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #006FFF;
    }
  
  
    .tab_cont {
      padding: 1px 22px 16px;
      box-sizing: border-box;
      overflow-y: auto;

      .key {
        font-size: 16px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #FFFFFF;
        line-height: 22px;
        margin-bottom: 12px;
        cursor: pointer;
      }
      .key:not(:first-child) {
        margin-top: 16px;
      }
      .value {
        flex-wrap: wrap;
        .valueItem {
          padding: 0 10px;
          height: 38px;
          line-height: 38px;
          background: #252739;
          border-radius: 4px;
          max-width: 265px;
          font-size: 15px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #CACAD4;
          overflow:hidden; //超出的文本隐藏
          text-overflow:ellipsis; //溢出用省略号显示
          white-space:nowrap; //溢出不换行
          width: auto;
          margin-right: 12px;
          margin-bottom: 12px;
          cursor: pointer;
        }
        .valueItem.active {
          background: linear-gradient(90deg, #252739 0%, #00449C 50%, #252739 100%);
        }
      }

    }


    .badge {
      position: absolute;
      z-index: 9;
      min-width: 20px;height: 20px;background: #EF4545;text-align: center;line-height: 16px;border-radius: 50%;top: -8px;right: -17px
    }
  }
}


/*去掉el-tab-pane底部灰色线条*/
::v-deep .deleteBorder .el-tabs__item {
  background-color: #252739;
}


::v-deep .deleteBorder .is-active{
  background-color: #111224;
}



::v-deep  .deleteBorder .el-tabs__active-bar {
  height: 0;
}

::v-deep   .deleteBorder   .el-tabs__nav-wrap::after {
  content: "";
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 0px;
  background-color: transparent;
  z-index: 1;
}


::v-deep  .previewDialog  {
background: transparent !important;
  .el-dialog__header {
    display: none;
  }
  .dj-dialog-content {
    padding: 0;
    overflow: unset;
  }
  .el-dialog__body {
    padding: 0;
  }
}
</style>